import { jobLists } from "character";
import { GameData, Job, RelicData, RelicIndex } from "enums";
import log from "logger";
import { RelicID, RelicImage } from "managers/types/relic-types";
import { OutputGameString, OutputString } from "translations/types";
import { Prerequisite } from "types/data";
import { Duty } from "types/game";
import utils from "util/utils";

type AvailableImages = { [key in Job]: string[]; }

export class RelicsManager {
	private availableImages:AvailableImages = {
		[Job.PLD]: [], [Job.WAR]: [], [Job.DRK]: [], [Job.GNB]: [],
		[Job.WHM]: [], [Job.SCH]: [], [Job.AST]: [], [Job.SGE]: [],
		[Job.MNK]: [], [Job.DRG]: [], [Job.NIN]: [], [Job.SAM]: [], [Job.RPR]: [], [Job.VPR]: [],
		[Job.BRD]: [], [Job.MCH]: [], [Job.DNC]: [],
		[Job.BLM]: [], [Job.SMN]: [], [Job.RDM]: [], [Job.PCT]: [],
		[Job.CRP]: [], [Job.BSM]: [], [Job.ARM]: [], [Job.GSM]: [], [Job.LTW]: [], [Job.WVR]: [], [Job.ALC]: [], [Job.CUL]: [],
		[Job.MIN]: [], [Job.BTN]: [], [Job.FSH]: [],
	};

	// Todo: Move this type

	// Todo: Create similar for other kinds of data like relics with names, ilevels etc

	private jobData:{ [Key in Job]: { shortName: OutputGameString, fullName: OutputGameString }} = {
		[Job.PLD]: { shortName: "PLD", fullName: "Paladin" },
		[Job.WAR]: { shortName: "WAR", fullName: "Warrior" },
		[Job.DRK]: { shortName: "DRK", fullName: "Dark Knight" },
		[Job.GNB]: { shortName: "GNB", fullName: "Gunbreaker" },
		[Job.WHM]: { shortName: "WHM", fullName: "White Mage" },
		[Job.SCH]: { shortName: "SCH", fullName: "Scholar" },
		[Job.AST]: { shortName: "AST", fullName: "Astrologian" },
		[Job.SGE]: { shortName: "SGE", fullName: "Sage" },
		[Job.MNK]: { shortName: "MNK", fullName: "Monk" },
		[Job.DRG]: { shortName: "DRG", fullName: "Dragoon" },
		[Job.NIN]: { shortName: "NIN", fullName: "Ninja" },
		[Job.SAM]: { shortName: "SAM", fullName: "Samurai" },
		[Job.RPR]: { shortName: "RPR", fullName: "Reaper" },
		[Job.VPR]: { shortName: "VPR", fullName: "Viper" },
		[Job.BRD]: { shortName: "BRD", fullName: "Bard" },
		[Job.MCH]: { shortName: "MCH", fullName: "Machinist" },
		[Job.DNC]: { shortName: "DNC", fullName: "Dancer" },
		[Job.BLM]: { shortName: "BLM", fullName: "Black Mage" },
		[Job.SMN]: { shortName: "SMN", fullName: "Summoner" },
		[Job.RDM]: { shortName: "RDM", fullName: "Red Mage" },
		[Job.PCT]: { shortName: "PCT", fullName: "Pictomancer" },
		[Job.CRP]: { shortName: "CRP", fullName: "Carpenter" },
		[Job.BSM]: { shortName: "BSM", fullName: "Blacksmith" },
		[Job.ARM]: { shortName: "ARM", fullName: "Armorer" },
		[Job.GSM]: { shortName: "GSM", fullName: "Goldsmith" },
		[Job.LTW]: { shortName: "LTW", fullName: "Leatherworker" },
		[Job.WVR]: { shortName: "WVR", fullName: "Weaver" },
		[Job.ALC]: { shortName: "ALC", fullName: "Alchemist" },
		[Job.CUL]: { shortName: "CUL", fullName: "Culinarian" },
		[Job.MIN]: { shortName: "MIN", fullName: "Miner" },
		[Job.BTN]: { shortName: "BTN", fullName: "Botanist" },
		[Job.FSH]: { shortName: "FSH", fullName: "Fisher" },
	}

	init():void{
		log.init(log.InitStatus.START, "Relics");

		let context; // require.context requires string literals due to static dependencies/requirements
		context = require.context("assets/images/relics/PLD", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.PLD] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/WAR", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.WAR] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/DRK", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.DRK] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/GNB", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.GNB] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/WHM", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.WHM] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/SCH", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.SCH] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/AST", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.AST] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/SGE", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.SGE] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/MNK", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.MNK] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/DRG", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.DRG] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/NIN", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.NIN] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/SAM", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.SAM] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/RPR", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.RPR] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/VPR", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.VPR] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/BRD", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.BRD] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/MCH", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.MCH] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/DNC", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.DNC] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/BLM", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.BLM] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/SMN", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.SMN] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/RDM", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.RDM] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/PCT", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.PCT] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/CRP", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.CRP] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/BSM", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.BSM] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/ARM", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.ARM] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/GSM", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.GSM] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/LTW", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.LTW] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/WVR", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.WVR] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/ALC", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.ALC] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/CUL", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.CUL] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/MIN", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.MIN] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/BTN", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.BTN] = context.keys().map(context) as string[];
		context = require.context("assets/images/relics/FSH", false, /^assets\/.*.(png|jpe?g|svg)$/); this.availableImages[Job.FSH] = context.keys().map(context) as string[];

		log.init(log.InitStatus.COMPLETE, "Relics");
	}

	getAllImages():RelicImage[]{
		const relicImages:RelicImage[] = [];

		jobLists.all.forEach((job) => {
			const imageList = this.availableImages[job];
			imageList.forEach((img) => {
				const startIndex = img.indexOf("/static/media/") + "/static/media/".length;
				const endIndex = img.indexOf(".");
				const relic = img.substring(startIndex, endIndex).split("-");
				relicImages.push({
					image: img,
					type: relic[0] as RelicData.Type,
					relic: relic[1] as RelicData.Group,
					part: relic[2] as RelicData.Part,
					job: job,
					relicName: this.getRelicNameKey(job, relic[2] as RelicData.Part),
				});
			});
		});
		return relicImages;
	}

	getJobName(job:Job):OutputGameString{
		const thisJob = this.jobData[job];
		if(!thisJob){ return "GUnknown"; }

		return this.jobData[job].fullName;
	}

	getRelicNameKey(job:Job, part:RelicData.Part):OutputGameString{
		const key = `relicname-${job}-${part}`;

		if(utils.guards.isOutputGameString(key)){ return key; }
		log.warn(`Unknown Relic Name Key: ${key}`);
		return "GUnknown";
	}

	getPartILvl(part:RelicData.Part):number{
		switch(part){
			default: return -1;
			case RelicData.Part.WEAPON_BASE_WEAPON: return 80;
			case RelicData.Part.WEAPON_ZENITH: return 90;
			case RelicData.Part.WEAPON_ATMA: return 100;
			case RelicData.Part.WEAPON_ANIMUS: return 100;
			case RelicData.Part.WEAPON_NOVUS: return 110;
			case RelicData.Part.WEAPON_NEXUS: return 115;
			case RelicData.Part.WEAPON_BRAVES: return 125;
			case RelicData.Part.WEAPON_ZETA: return 135;
			case RelicData.Part.WEAPON_ANIMATED: return 170;
			case RelicData.Part.WEAPON_AWOKEN: return 200;
			case RelicData.Part.WEAPON_ANIMA: return 210;
			case RelicData.Part.WEAPON_HYPERCONDUCTIVE: return 230;
			case RelicData.Part.WEAPON_RECONDITIONED: return 240;
			case RelicData.Part.WEAPON_SHARPENED: return 260;
			case RelicData.Part.WEAPON_COMPLETE: return 270;
			case RelicData.Part.WEAPON_LUX: return 275;
			case RelicData.Part.WEAPON_ANTIQUATED: return 290;
			case RelicData.Part.WEAPON_ANEMOS: return 355;
			case RelicData.Part.WEAPON_ELEMENTAL: return 370;
			case RelicData.Part.WEAPON_PYROS: return 385;
			case RelicData.Part.WEAPON_EUREKA: return 405;
			case RelicData.Part.WEAPON_PHYSEOS: return 405;
			case RelicData.Part.WEAPON_RESISTANCE: return 485;
			case RelicData.Part.WEAPON_AUGMENTED_RESISTANCE: return 500;
			case RelicData.Part.WEAPON_RECOLLECTION: return 500;
			case RelicData.Part.WEAPON_LAWS_ORDER: return 510;
			case RelicData.Part.WEAPON_AUGMENTED_LAWS_ORDER: return 515;
			case RelicData.Part.WEAPON_BLADE: return 535;
			case RelicData.Part.WEAPON_MANDERVILLE: return 615;
			case RelicData.Part.WEAPON_AMAZING_MANDERVILLE: return 630;
			case RelicData.Part.WEAPON_MAJESTIC_MANDERVILLE: return 645;
			case RelicData.Part.WEAPON_MANDERVILLOUS: return 665;
			case RelicData.Part.WEAPON_PENUMBRAE: return 745;
			case RelicData.Part.WEAPON_UMBRAE: return 760;
			case RelicData.Part.WEAPON_OBSCURUM: return 775;
			case RelicData.Part.WEAPON_ECLIPTICUM: return 790;
			case RelicData.Part.WEAPON_OCCULTUM: return 795;
			case RelicData.Part.TOOL_MASTERCRAFT: return 55;
			case RelicData.Part.TOOL_SUPRA: return 75;
			case RelicData.Part.TOOL_LUCIS: return 90;
			case RelicData.Part.TOOL_SKYSTEEL: return 440;
			case RelicData.Part.TOOL_SKYSTEEL_1: return 455;
			case RelicData.Part.TOOL_DRAGONSUNG: return 475;
			case RelicData.Part.TOOL_AUGMENTED_DRAGONSUNG: return 485;
			case RelicData.Part.TOOL_SKYSUNG: return 500;
			case RelicData.Part.TOOL_SKYBUILDERS: return 510;
			case RelicData.Part.TOOL_RESPLENDENT: return 500;
			case RelicData.Part.TOOL_SPLENDOROUS: return 570;
			case RelicData.Part.TOOL_AUGMENTED_SPLENDOROUS: return 590;
			case RelicData.Part.TOOL_CRYSTALLINE: return 620;
			case RelicData.Part.TOOL_CHORA_ZOIS_CRYSTALLINE: return 625;
			case RelicData.Part.TOOL_BRILLIANT: return 630;
			case RelicData.Part.TOOL_VRANDTIC_VISIONARYS: return 635;
			case RelicData.Part.TOOL_LODESTAR: return 640;
			case RelicData.Part.TOOL_COSMIC: return 720;
			case RelicData.Part.TOOL_STELLAR: return 750;
			case RelicData.Part.TOOL_HYPER: return 765;
			case RelicData.Part.TOOL_STARS: return 780;
			case RelicData.Part.ARMOUR_ANTIQUATED: return 290;
			case RelicData.Part.ARMOUR_BASE_0: return 335;
			case RelicData.Part.ARMOUR_BASE_1: return 340;
			case RelicData.Part.ARMOUR_BASE_2: return 345;
			case RelicData.Part.ARMOUR_ANEMOS: return 350;
			case RelicData.Part.ARMOUR_ELEMENTAL: return 380;
			case RelicData.Part.ARMOUR_ELEMENTAL_1: return 390;
			case RelicData.Part.ARMOUR_ELEMENTAL_2: return 390;
			case RelicData.Part.ARMOUR_BOZJAN: return 495;
			case RelicData.Part.ARMOUR_AUGMENTED_BOZJAN: return 495;
			case RelicData.Part.ARMOUR_LAWS_ORDER: return 510;
			case RelicData.Part.ARMOUR_AUGMENTED_LAWS_ORDER: return 510;
			case RelicData.Part.ARMOUR_BLADES: return 525;
		}
	}

	isFirstTimeOnlyStep(step:RelicData.Step):boolean{
		return [
			RelicData.Step.ARMS,
			RelicData.Step.TRIALS,
			RelicData.Step.RADIANCE,
			RelicData.Step.STAR,
			RelicData.Step.SOULGLAZE,
			RelicData.Step.WHEREFORE,
			RelicData.Step.MATERIA,
			RelicData.Step.SHINE,
			RelicData.Step.VITAL,
			RelicData.Step.REMEMBERS,
			RelicData.Step.SPARE_PARTS,
			RelicData.Step.STORY,
			RelicData.Step.FOND_MEMORY,
			RelicData.Step.DEAL,
			RelicData.Step.DEMIATMA,
			RelicData.Step.UMBRAE_ITEMS,
			RelicData.Step.AETHERWELL,
			RelicData.Step.OBSCURUM_ITEMS,
			RelicData.Step.CRYSTAL_PASTE,
			RelicData.Step.ECLIPTICUM_ITEMS,
			RelicData.Step.PHANTOM_DISPELLER,
			RelicData.Step.KNOWLEDGE,
		].includes(step);
	}

	getRelicType(relic:RelicData.Group):RelicData.Type{
		const typeStr = relic.substring(2, 3);
		switch(typeStr){
			default:
			case "w": return RelicData.Type.WEAPON;
			case "t": return RelicData.Type.TOOL;
			case "a": return RelicData.Type.ARMOUR;
		}
	}

	getRelicPartsForRelic(relic:RelicData.Group):RelicData.Part[]{
		switch(relic){
			default: return [];
			case RelicData.Group.WEAPON_ZODIAC: return [RelicData.Part.WEAPON_BASE_WEAPON, RelicData.Part.WEAPON_ZENITH, RelicData.Part.WEAPON_ATMA, RelicData.Part.WEAPON_ANIMUS, RelicData.Part.WEAPON_NOVUS, RelicData.Part.WEAPON_NEXUS, RelicData.Part.WEAPON_BRAVES, RelicData.Part.WEAPON_ZETA];
			case RelicData.Group.WEAPON_ANIMA: return [RelicData.Part.WEAPON_ANIMATED, RelicData.Part.WEAPON_AWOKEN, RelicData.Part.WEAPON_ANIMA, RelicData.Part.WEAPON_HYPERCONDUCTIVE, RelicData.Part.WEAPON_RECONDITIONED, RelicData.Part.WEAPON_SHARPENED, RelicData.Part.WEAPON_COMPLETE, RelicData.Part.WEAPON_LUX];
			case RelicData.Group.WEAPON_EUREKA: return [RelicData.Part.WEAPON_ANTIQUATED, RelicData.Part.WEAPON_ANEMOS, RelicData.Part.WEAPON_ELEMENTAL, RelicData.Part.WEAPON_PYROS, RelicData.Part.WEAPON_EUREKA, RelicData.Part.WEAPON_PHYSEOS];
			case RelicData.Group.WEAPON_RESISTANCE: return [RelicData.Part.WEAPON_RESISTANCE, RelicData.Part.WEAPON_AUGMENTED_RESISTANCE, RelicData.Part.WEAPON_RECOLLECTION, RelicData.Part.WEAPON_LAWS_ORDER, RelicData.Part.WEAPON_AUGMENTED_LAWS_ORDER, RelicData.Part.WEAPON_BLADE];
			case RelicData.Group.WEAPON_MANDERVILLE: return [RelicData.Part.WEAPON_MANDERVILLE, RelicData.Part.WEAPON_AMAZING_MANDERVILLE, RelicData.Part.WEAPON_MAJESTIC_MANDERVILLE, RelicData.Part.WEAPON_MANDERVILLOUS];
			case RelicData.Group.WEAPON_PHANTOM: return [RelicData.Part.WEAPON_PENUMBRAE, RelicData.Part.WEAPON_UMBRAE, RelicData.Part.WEAPON_OBSCURUM, RelicData.Part.WEAPON_ECLIPTICUM, RelicData.Part.WEAPON_OCCULTUM];
			case RelicData.Group.TOOL_LUCIS: return [RelicData.Part.TOOL_MASTERCRAFT, RelicData.Part.TOOL_SUPRA, RelicData.Part.TOOL_LUCIS];
			case RelicData.Group.TOOL_SKYSTEEL: return [RelicData.Part.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSTEEL_1, RelicData.Part.TOOL_DRAGONSUNG, RelicData.Part.TOOL_AUGMENTED_DRAGONSUNG, RelicData.Part.TOOL_SKYSUNG, RelicData.Part.TOOL_SKYBUILDERS];
			case RelicData.Group.TOOL_SPLENDOROUS: return [RelicData.Part.TOOL_SPLENDOROUS, RelicData.Part.TOOL_AUGMENTED_SPLENDOROUS, RelicData.Part.TOOL_CRYSTALLINE, RelicData.Part.TOOL_CHORA_ZOIS_CRYSTALLINE, RelicData.Part.TOOL_BRILLIANT, RelicData.Part.TOOL_VRANDTIC_VISIONARYS, RelicData.Part.TOOL_LODESTAR];
			case RelicData.Group.TOOL_COSMIC: return [RelicData.Part.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Part.TOOL_HYPER, RelicData.Part.TOOL_STARS];
			case RelicData.Group.ARMOUR_ANEMOS: return [RelicData.Part.ARMOUR_ANTIQUATED, RelicData.Part.ARMOUR_BASE_0, RelicData.Part.ARMOUR_BASE_1, RelicData.Part.ARMOUR_BASE_2, RelicData.Part.ARMOUR_ANEMOS];
			case RelicData.Group.ARMOUR_ELEMENTAL: return [RelicData.Part.ARMOUR_ELEMENTAL, RelicData.Part.ARMOUR_ELEMENTAL_1, RelicData.Part.ARMOUR_ELEMENTAL_2];
			case RelicData.Group.ARMOUR_BOZJAN: return [RelicData.Part.ARMOUR_BOZJAN, RelicData.Part.ARMOUR_AUGMENTED_BOZJAN];
			case RelicData.Group.ARMOUR_LAWS_ORDER: return [RelicData.Part.ARMOUR_LAWS_ORDER, RelicData.Part.ARMOUR_AUGMENTED_LAWS_ORDER];
			case RelicData.Group.ARMOUR_BLADES: return [RelicData.Part.ARMOUR_BLADES];
		}
	}

	private addToPreReqs(preReqs:Prerequisite[], stepArr:RelicData.Step[], thisType:RelicData.Type, thisRelic:RelicData.Group, thisPart:RelicData.Part, thisStep:RelicData.Step):Prerequisite[]{
		let addToReqs = false;
		stepArr.forEach((step, index) => {
			if(thisStep === step){ addToReqs = true; }
			const thisRelicID = `${thisType}-${thisRelic}-${thisPart}-${step}`;

			const nextStep = stepArr[index + 1];
			const nextRelicId = nextStep ? `${thisType}-${thisRelic}-${thisPart}-${nextStep}` : null;

			if(utils.guards.isRelicId(thisRelicID) && (nextRelicId === null || utils.guards.isRelicId(nextRelicId))){
				if(addToReqs && preReqs.findIndex((z) => { return z.id === thisRelicID; }) === -1){
					preReqs.push({ id: thisRelicID, nextId: nextRelicId });
				}
			}
		});

		return preReqs;
	}

	findPrerequisites(relicId:RelicID, value:boolean):Prerequisite[]{
		const relicFromId = utils.helpers.getRelicFromId(relicId);

		if(relicFromId[RelicIndex.RELIC] === RelicData.Group.WEAPON_ZODIAC){ return this.getWeaponZodiacPreReqs(relicFromId[RelicIndex.PART], relicFromId[RelicIndex.STEP], value); }
		if(relicFromId[RelicIndex.RELIC] === RelicData.Group.WEAPON_ANIMA){ return this.getWeaponAnimaPreReqs(relicFromId[RelicIndex.PART], relicFromId[RelicIndex.STEP], value); }
		if(relicFromId[RelicIndex.RELIC] === RelicData.Group.WEAPON_EUREKA){ return this.getWeaponEurekaPreReqs(relicFromId[RelicIndex.PART], relicFromId[RelicIndex.STEP], value); }
		if(relicFromId[RelicIndex.RELIC] === RelicData.Group.WEAPON_RESISTANCE){ return this.getWeaponResistancePreReqs(relicFromId[RelicIndex.PART], relicFromId[RelicIndex.STEP], value); }
		if(relicFromId[RelicIndex.RELIC] === RelicData.Group.WEAPON_MANDERVILLE){ return this.getWeaponMandervillePreReqs(relicFromId[RelicIndex.PART], relicFromId[RelicIndex.STEP], value); }
		if(relicFromId[RelicIndex.RELIC] === RelicData.Group.WEAPON_PHANTOM){ return this.getWeaponPhantomPreReqs(relicFromId[RelicIndex.PART], relicFromId[RelicIndex.STEP], value); }
		if(relicFromId[RelicIndex.RELIC] === RelicData.Group.TOOL_LUCIS){ return this.getToolLucisPreReqs(relicFromId[RelicIndex.PART], relicFromId[RelicIndex.STEP], value); }
		if(relicFromId[RelicIndex.RELIC] === RelicData.Group.TOOL_SKYSTEEL){ return this.getToolSkysteelPreReqs(relicFromId[RelicIndex.PART], relicFromId[RelicIndex.STEP], value); }
		if(relicFromId[RelicIndex.RELIC] === RelicData.Group.TOOL_SPLENDOROUS){ return this.getToolSplendorousPreReqs(relicFromId[RelicIndex.PART], relicFromId[RelicIndex.STEP], value); }
		if(relicFromId[RelicIndex.RELIC] === RelicData.Group.TOOL_COSMIC){ return this.getToolCosmicPreReqs(relicFromId[RelicIndex.PART], relicFromId[RelicIndex.STEP], value); }
		return [];
	}

	getWeaponZodiacPreReqs(part:RelicData.Part, step:RelicData.Step, value:boolean):Prerequisite[]{
		const preReqs:Prerequisite[] = [];
		let stepArr:RelicData.Step[] = [];

		switch(part){
			default: log.warn(`No PreReqs found for ${part}`); return [];
			case RelicData.Part.WEAPON_BASE_WEAPON:
				stepArr = [RelicData.Step.OIL, RelicData.Step.ORE, RelicData.Step.GALE, RelicData.Step.EMBER, RelicData.Step.HYDRA, RelicData.Step.BEASTMAN, RelicData.Step.AMDAPOR, RelicData.Step.CHIMERA, RelicData.Step.CLASS_WEAPON, RelicData.Step.BROKEN_WEAPON];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, part, step);

				if(!value){ preReqs.push(...this.getWeaponZodiacPreReqs(RelicData.Part.WEAPON_ZENITH, RelicData.Step.MIST, value)); } // Next part, First step
				break;
			case RelicData.Part.WEAPON_ZENITH:
				stepArr = [RelicData.Step.MIST];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, part, step);

				if(value){ preReqs.push(...this.getWeaponZodiacPreReqs(RelicData.Part.WEAPON_BASE_WEAPON, RelicData.Step.OIL, value)); } // Previous part, Last step
				else{ preReqs.push(...this.getWeaponZodiacPreReqs(RelicData.Part.WEAPON_ATMA, RelicData.Step.ARMS, value)); } // Next part, First step
				break;
			case RelicData.Part.WEAPON_ATMA:
				stepArr = [RelicData.Step.ATMAS, RelicData.Step.ARMS];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, part, step);

				if(value){ preReqs.push(...this.getWeaponZodiacPreReqs(RelicData.Part.WEAPON_ZENITH, RelicData.Step.MIST, value)); }
				else{ preReqs.push(...this.getWeaponZodiacPreReqs(RelicData.Part.WEAPON_ANIMUS, RelicData.Step.TRIALS, value)); }
				break;
			case RelicData.Part.WEAPON_ANIMUS:
				switch(step){
					default:
					case RelicData.Step.TRIALS:
						stepArr = [RelicData.Step.SKYEARTH_1, RelicData.Step.SKYWIND_2, RelicData.Step.SKYWIND_1, RelicData.Step.NETHERFALL_1, RelicData.Step.SKYFALL_2, RelicData.Step.SKYFALL_1, RelicData.Step.NETHERFIRE_1, RelicData.Step.SKYFIRE_2, RelicData.Step.SKYFIRE_1];
						break;
					case RelicData.Step.SKYFIRE_1:
					case RelicData.Step.SKYFIRE_2:
					case RelicData.Step.NETHERFIRE_1:
						stepArr = [RelicData.Step.NETHERFIRE_1, RelicData.Step.SKYFIRE_2, RelicData.Step.SKYFIRE_1];
						break;
					case RelicData.Step.SKYFALL_1:
					case RelicData.Step.SKYFALL_2:
					case RelicData.Step.NETHERFALL_1:
						stepArr = [RelicData.Step.NETHERFALL_1, RelicData.Step.SKYFALL_2, RelicData.Step.SKYFALL_1];
						break;
					case RelicData.Step.SKYWIND_1:
					case RelicData.Step.SKYWIND_2:
						stepArr = [RelicData.Step.SKYWIND_2, RelicData.Step.SKYWIND_1];
						break;
					case RelicData.Step.SKYEARTH_1:
						stepArr = [RelicData.Step.SKYEARTH_1];
						break;
				}

				stepArr.push(RelicData.Step.TRIALS);

				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, part, step);

				if(value){ preReqs.push(...this.getWeaponZodiacPreReqs(RelicData.Part.WEAPON_ATMA, RelicData.Step.ATMAS, value)); }
				else{ preReqs.push(...this.getWeaponZodiacPreReqs(RelicData.Part.WEAPON_NOVUS, RelicData.Step.RADIANCE, value)); }
				break;
			case RelicData.Part.WEAPON_NOVUS:
				stepArr = [RelicData.Step.BINDING, RelicData.Step.ALEXANDRITE, RelicData.Step.STAR, RelicData.Step.SCROLL, RelicData.Step.RADIANCE];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, part, step);

				if(value){
					// Will need to add each set of requirements in order to check all
					preReqs.push(...this.getWeaponZodiacPreReqs(RelicData.Part.WEAPON_ANIMUS, RelicData.Step.SKYEARTH_1, value));
					preReqs.push(...this.getWeaponZodiacPreReqs(RelicData.Part.WEAPON_ANIMUS, RelicData.Step.SKYWIND_2, value));
					preReqs.push(...this.getWeaponZodiacPreReqs(RelicData.Part.WEAPON_ANIMUS, RelicData.Step.NETHERFALL_1, value));
					preReqs.push(...this.getWeaponZodiacPreReqs(RelicData.Part.WEAPON_ANIMUS, RelicData.Step.NETHERFIRE_1, value));
				}else{
					preReqs.push(...this.getWeaponZodiacPreReqs(RelicData.Part.WEAPON_NEXUS, RelicData.Step.SOULGLAZE, value));
				}
				break;
			case RelicData.Part.WEAPON_NEXUS:
				stepArr = [RelicData.Step.LIGHT, RelicData.Step.SOULGLAZE];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, part, step);

				if(value){ preReqs.push(...this.getWeaponZodiacPreReqs(RelicData.Part.WEAPON_NOVUS, RelicData.Step.BINDING, value)); }
				else{ preReqs.push(...this.getWeaponZodiacPreReqs(RelicData.Part.WEAPON_BRAVES, RelicData.Step.WHEREFORE, value)); }
				break;
			case RelicData.Part.WEAPON_BRAVES:
				stepArr = [RelicData.Step.MATERIA, RelicData.Step.BRAVES_SCROLL, RelicData.Step.FLAWLESS_ALEXANDRITE, RelicData.Step.ZODIUM, RelicData.Step.SKYLIGHT, RelicData.Step.WHEREFORE];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, part, step);

				if(value){ preReqs.push(...this.getWeaponZodiacPreReqs(RelicData.Part.WEAPON_NEXUS, RelicData.Step.LIGHT, value)); }
				else{ preReqs.push(...this.getWeaponZodiacPreReqs(RelicData.Part.WEAPON_ZETA, RelicData.Step.SHINE, value)); }
				break;
			case RelicData.Part.WEAPON_ZETA:
				stepArr = [RelicData.Step.VITAL, RelicData.Step.SOUL, RelicData.Step.SHINE];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, part, step);

				if(value){ preReqs.push(...this.getWeaponZodiacPreReqs(RelicData.Part.WEAPON_BRAVES, RelicData.Step.MATERIA, value)); }
				break;
		}
		return preReqs;
	}

	getWeaponAnimaPreReqs(part:RelicData.Part, step:RelicData.Step, value:boolean):Prerequisite[]{
		const preReqs:Prerequisite[] = [];
		let stepArr:RelicData.Step[] = [];

		switch(part){
			default: log.warn(`No PreReqs found for ${part}`); return [];
			case RelicData.Part.WEAPON_ANIMATED:
				stepArr = [RelicData.Step.CRYSTALS];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, part, step);

				if(!value){ preReqs.push(...this.getWeaponAnimaPreReqs(RelicData.Part.WEAPON_AWOKEN, RelicData.Step.SNOWCLOAK, value)); }
				break;
			case RelicData.Part.WEAPON_AWOKEN:
				stepArr = [RelicData.Step.VAULT, RelicData.Step.AERY, RelicData.Step.SOHM, RelicData.Step.VIGIL, RelicData.Step.AMDAPOR_AWOKEN, RelicData.Step.WANDERER, RelicData.Step.KEEPER, RelicData.Step.QARN, RelicData.Step.SASTASHA, RelicData.Step.SNOWCLOAK];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, part, step);

				if(value){ preReqs.push(...this.getWeaponAnimaPreReqs(RelicData.Part.WEAPON_ANIMATED, RelicData.Step.CRYSTALS, value)); }
				else{ preReqs.push(...this.getWeaponAnimaPreReqs(RelicData.Part.WEAPON_ANIMA, RelicData.Step.RUBBER, value)); }
				break;
			case RelicData.Part.WEAPON_ANIMA:
				stepArr = [RelicData.Step.CATALYST, RelicData.Step.WATER, RelicData.Step.CARBONCOAT, RelicData.Step.RUBBER];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, part, step);

				if(value){ preReqs.push(...this.getWeaponAnimaPreReqs(RelicData.Part.WEAPON_AWOKEN, RelicData.Step.VAULT, value)); }
				else{ preReqs.push(...this.getWeaponAnimaPreReqs(RelicData.Part.WEAPON_HYPERCONDUCTIVE, RelicData.Step.OIL_HYPER, value)); }
				break;
			case RelicData.Part.WEAPON_HYPERCONDUCTIVE:
				stepArr = [RelicData.Step.OIL_HYPER];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, part, step);

				if(value){ preReqs.push(...this.getWeaponAnimaPreReqs(RelicData.Part.WEAPON_ANIMA, RelicData.Step.CATALYST, value)); }
				else{ preReqs.push(...this.getWeaponAnimaPreReqs(RelicData.Part.WEAPON_RECONDITIONED, RelicData.Step.SAND, value)); }
				break;
			case RelicData.Part.WEAPON_RECONDITIONED:
				stepArr = [RelicData.Step.SAND];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, part, step);

				if(value){ preReqs.push(...this.getWeaponAnimaPreReqs(RelicData.Part.WEAPON_HYPERCONDUCTIVE, RelicData.Step.OIL_HYPER, value)); }
				else{ preReqs.push(...this.getWeaponAnimaPreReqs(RelicData.Part.WEAPON_SHARPENED, RelicData.Step.CLUSTERS, value)); }
				break;
			case RelicData.Part.WEAPON_SHARPENED:
				stepArr = [RelicData.Step.CLUSTERS];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, part, step);

				if(value){ preReqs.push(...this.getWeaponAnimaPreReqs(RelicData.Part.WEAPON_RECONDITIONED, RelicData.Step.SAND, value)); }
				else{ preReqs.push(...this.getWeaponAnimaPreReqs(RelicData.Part.WEAPON_COMPLETE, RelicData.Step.DUNGEONS, value)); }
				break;
			case RelicData.Part.WEAPON_COMPLETE:
				stepArr = [RelicData.Step.DENSITY, RelicData.Step.PNEUMITE, RelicData.Step.DUNGEONS];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, part, step);

				if(value){ preReqs.push(...this.getWeaponAnimaPreReqs(RelicData.Part.WEAPON_SHARPENED, RelicData.Step.CLUSTERS, value)); }
				else{ preReqs.push(...this.getWeaponAnimaPreReqs(RelicData.Part.WEAPON_LUX, RelicData.Step.BFF, value)); }
				break;
			case RelicData.Part.WEAPON_LUX:
				stepArr = [RelicData.Step.BFF];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, part, step);

				if(value){ preReqs.push(...this.getWeaponAnimaPreReqs(RelicData.Part.WEAPON_COMPLETE, RelicData.Step.DENSITY, value)); }
				break;
		}
		return preReqs;
	}

	getWeaponEurekaPreReqs(part:RelicData.Part, step:RelicData.Step, value:boolean):Prerequisite[]{
		const preReqs:Prerequisite[] = [];
		let stepArr:RelicData.Step[] = [];

		switch(part){
			default: log.warn(`No PreReqs found for ${part}`); return [];
			case RelicData.Part.WEAPON_ANTIQUATED:
				stepArr = [RelicData.Step.ANTIQUATED]; // Steps in reverse order
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, part, step);

				if(!value){ preReqs.push(...this.getWeaponEurekaPreReqs(RelicData.Part.WEAPON_ANEMOS, RelicData.Step.ANEMOS_0, value)); } // Next Part, First Step
				break;
			case RelicData.Part.WEAPON_ANEMOS:
				stepArr = [RelicData.Step.ANEMOS, RelicData.Step.ANEMOS_2, RelicData.Step.ANEMOS_1, RelicData.Step.ANEMOS_0]; // Steps in reverse order
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, part, step);

				if(value){ preReqs.push(...this.getWeaponEurekaPreReqs(RelicData.Part.WEAPON_ANTIQUATED, RelicData.Step.ANTIQUATED, value)); } // Previous part, Last step
				else{ preReqs.push(...this.getWeaponEurekaPreReqs(RelicData.Part.WEAPON_ELEMENTAL, RelicData.Step.PAGOS, value)); } // Next part, First step
				break;
			case RelicData.Part.WEAPON_ELEMENTAL:
				stepArr = [RelicData.Step.ELEMENTAL, RelicData.Step.PAGOS_1, RelicData.Step.PAGOS]; // Steps in reverse order
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, part, step);

				if(value){ preReqs.push(...this.getWeaponEurekaPreReqs(RelicData.Part.WEAPON_ANEMOS, RelicData.Step.ANEMOS, value)); } // Previous part, Last step
				else{ preReqs.push(...this.getWeaponEurekaPreReqs(RelicData.Part.WEAPON_PYROS, RelicData.Step.ELEMENTAL_1, value)); } // Next part, First step
				break;
			case RelicData.Part.WEAPON_PYROS:
				stepArr = [RelicData.Step.PYROS, RelicData.Step.ELEMENTAL_2, RelicData.Step.ELEMENTAL_1]; // Steps in reverse order
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, part, step);

				if(value){ preReqs.push(...this.getWeaponEurekaPreReqs(RelicData.Part.WEAPON_ELEMENTAL, RelicData.Step.ELEMENTAL, value)); } // Previous part, Last step
				else{ preReqs.push(...this.getWeaponEurekaPreReqs(RelicData.Part.WEAPON_EUREKA, RelicData.Step.HYDATOS, value)); } // Next part, First step
				break;
			case RelicData.Part.WEAPON_EUREKA:
				stepArr = [RelicData.Step.EUREKA, RelicData.Step.BASE, RelicData.Step.HYDATOS_1, RelicData.Step.HYDATOS]; // Steps in reverse order
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, part, step);

				if(value){ preReqs.push(...this.getWeaponEurekaPreReqs(RelicData.Part.WEAPON_PYROS, RelicData.Step.PYROS, value)); } // Previous part, Last step
				else{ preReqs.push(...this.getWeaponEurekaPreReqs(RelicData.Part.WEAPON_PHYSEOS, RelicData.Step.FRAGMENTS, value)); } // Next part, First step
				break;
			case RelicData.Part.WEAPON_PHYSEOS:
				stepArr = [RelicData.Step.FRAGMENTS]; // Steps in reverse order
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, part, step);

				if(value){ preReqs.push(...this.getWeaponEurekaPreReqs(RelicData.Part.WEAPON_EUREKA, RelicData.Step.EUREKA, value)); } // Previous part, Last step
				break;
		}
		return preReqs;
	}

	getWeaponResistancePreReqs(part:RelicData.Part, step:RelicData.Step, value:boolean):Prerequisite[]{
		const preReqs:Prerequisite[] = [];
		let stepArr:RelicData.Step[] = [];

		switch(part){
			default: log.warn(`No PreReqs found for ${part}`); return [];
			case RelicData.Part.WEAPON_RESISTANCE:
				stepArr = [RelicData.Step.SCALEPOWDER]; // Steps in reverse order
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, part, step);

				if(!value){ preReqs.push(...this.getWeaponResistancePreReqs(RelicData.Part.WEAPON_AUGMENTED_RESISTANCE, RelicData.Step.MEMORY, value)); } // Next Part, First Step
				break;
			case RelicData.Part.WEAPON_AUGMENTED_RESISTANCE:
				stepArr = [RelicData.Step.MEMORY]; // Steps in reverse order
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, part, step);

				if(value){ preReqs.push(...this.getWeaponResistancePreReqs(RelicData.Part.WEAPON_RESISTANCE, RelicData.Step.SCALEPOWDER, value)); } // Previous part, Last step
				else{ preReqs.push(...this.getWeaponResistancePreReqs(RelicData.Part.WEAPON_RECOLLECTION, RelicData.Step.RESIST, value)); } // Next part, First step
				break;
			case RelicData.Part.WEAPON_RECOLLECTION:
				stepArr = [RelicData.Step.RESIST]; // Steps in reverse order
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, part, step);

				if(value){ preReqs.push(...this.getWeaponResistancePreReqs(RelicData.Part.WEAPON_AUGMENTED_RESISTANCE, RelicData.Step.MEMORY, value)); } // Previous part, Last step
				else{ preReqs.push(...this.getWeaponResistancePreReqs(RelicData.Part.WEAPON_LAWS_ORDER, RelicData.Step.CHANGE_OF_ARMS, value)); } // Next part, First step
				break;
			case RelicData.Part.WEAPON_LAWS_ORDER:
				stepArr = [RelicData.Step.CHANGE_OF_ARMS]; // Steps in reverse order
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, part, step);

				if(value){ preReqs.push(...this.getWeaponResistancePreReqs(RelicData.Part.WEAPON_RECOLLECTION, RelicData.Step.RESIST, value)); } // Previous part, Last step
				else{ preReqs.push(...this.getWeaponResistancePreReqs(RelicData.Part.WEAPON_AUGMENTED_LAWS_ORDER, RelicData.Step.REMEMBERS, value)); } // Next part, First step
				break;
			case RelicData.Part.WEAPON_AUGMENTED_LAWS_ORDER:
				stepArr = [RelicData.Step.PATH, RelicData.Step.REMEMBERS]; // Steps in reverse order
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, part, step);

				if(value){ preReqs.push(...this.getWeaponResistancePreReqs(RelicData.Part.WEAPON_LAWS_ORDER, RelicData.Step.CHANGE_OF_ARMS, value)); } // Previous part, Last step
				else{ preReqs.push(...this.getWeaponResistancePreReqs(RelicData.Part.WEAPON_BLADE, RelicData.Step.SPARE_PARTS, value)); } // Next part, First step
				break;
			case RelicData.Part.WEAPON_BLADE:
				stepArr = [RelicData.Step.IRRESISTIBLE, RelicData.Step.DEAL, RelicData.Step.FOND_MEMORY, RelicData.Step.STORY, RelicData.Step.SPARE_PARTS]; // Steps in reverse order
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, part, step);

				if(value){ preReqs.push(...this.getWeaponResistancePreReqs(RelicData.Part.WEAPON_AUGMENTED_LAWS_ORDER, RelicData.Step.PATH, value)); } // Previous part, Last step
				break;
		}
		return preReqs;
	}

	getWeaponMandervillePreReqs(part:RelicData.Part, step:RelicData.Step, value:boolean):Prerequisite[]{
		const preReqs:Prerequisite[] = [];
		let stepArr:RelicData.Step[] = [];

		switch(part){
			default: log.warn(`No PreReqs found for ${part}`); return [];
			case RelicData.Part.WEAPON_MANDERVILLE:
				stepArr = [RelicData.Step.MANDERVILLE]; // Steps in reverse order
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_MANDERVILLE, part, step);

				if(!value){ preReqs.push(...this.getWeaponMandervillePreReqs(RelicData.Part.WEAPON_AMAZING_MANDERVILLE, RelicData.Step.AMAZING_MANDERVILLE, value)); } // Next Part, First Step
				break;
			case RelicData.Part.WEAPON_AMAZING_MANDERVILLE:
				stepArr = [RelicData.Step.AMAZING_MANDERVILLE]; // Steps in reverse order
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_MANDERVILLE, part, step);

				if(value){ preReqs.push(...this.getWeaponMandervillePreReqs(RelicData.Part.WEAPON_MANDERVILLE, RelicData.Step.MANDERVILLE, value)); } // Previous part, Last step
				else{ preReqs.push(...this.getWeaponMandervillePreReqs(RelicData.Part.WEAPON_MAJESTIC_MANDERVILLE, RelicData.Step.MAJESTIC_MANDERVILLE, value)); } // Next part, First step
				break;
			case RelicData.Part.WEAPON_MAJESTIC_MANDERVILLE:
				stepArr = [RelicData.Step.MAJESTIC_MANDERVILLE]; // Steps in reverse order
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_MANDERVILLE, part, step);

				if(value){ preReqs.push(...this.getWeaponMandervillePreReqs(RelicData.Part.WEAPON_AMAZING_MANDERVILLE, RelicData.Step.AMAZING_MANDERVILLE, value)); } // Previous part, Last step
				else{ preReqs.push(...this.getWeaponMandervillePreReqs(RelicData.Part.WEAPON_MANDERVILLOUS, RelicData.Step.MANDERVILLOUS, value)); } // Next part, First step
				break;
			case RelicData.Part.WEAPON_MANDERVILLOUS:
				stepArr = [RelicData.Step.MANDERVILLOUS]; // Steps in reverse order
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_MANDERVILLE, part, step);

				if(value){ preReqs.push(...this.getWeaponMandervillePreReqs(RelicData.Part.WEAPON_MAJESTIC_MANDERVILLE, RelicData.Step.MAJESTIC_MANDERVILLE, value)); } // Previous part, Last step
				break;
		}
		return preReqs;
	}

	getWeaponPhantomPreReqs(part:RelicData.Part, step:RelicData.Step, value:boolean):Prerequisite[]{
		const preReqs:Prerequisite[] = [];
		let stepArr:RelicData.Step[] = [];

		switch(part){
			default: log.warn(`No PreReqs found for ${part}`); return [];
			case RelicData.Part.WEAPON_PENUMBRAE:
				stepArr = [RelicData.Step.ARCANITE, RelicData.Step.DEMIATMA]; // Steps in reverse order
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, part, step);

				if(!value){ preReqs.push(...this.getWeaponPhantomPreReqs(RelicData.Part.WEAPON_UMBRAE, RelicData.Step.UMBRAE_ITEMS, value)); } // Next part, First step
				break;
			case RelicData.Part.WEAPON_UMBRAE:
				stepArr = [RelicData.Step.WAXING_ARCANITE, RelicData.Step.AETHERWELL, RelicData.Step.UMBRAE_ITEMS]; // Steps in reverse order
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, part, step);
				if(value){ preReqs.push(...this.getWeaponPhantomPreReqs(RelicData.Part.WEAPON_PENUMBRAE, RelicData.Step.ARCANITE, value)); } // Previous part, Last step
				else{ preReqs.push(...this.getWeaponPhantomPreReqs(RelicData.Part.WEAPON_OBSCURUM, RelicData.Step.OBSCURUM_ITEMS, value)); } // Next part, First step
				break;
			case RelicData.Part.WEAPON_OBSCURUM:
				stepArr = [RelicData.Step.WANING_ARCANITE, RelicData.Step.CRYSTAL_PASTE, RelicData.Step.OBSCURUM_ITEMS]; // Steps in reverse order
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, part, step);
				if(value){ preReqs.push(...this.getWeaponPhantomPreReqs(RelicData.Part.WEAPON_UMBRAE, RelicData.Step.WAXING_ARCANITE, value)); } // Previous part, Last step
				else{ preReqs.push(...this.getWeaponPhantomPreReqs(RelicData.Part.WEAPON_ECLIPTICUM, RelicData.Step.ECLIPTICUM_ITEMS, value)); } // Next part, First step
				break;
			case RelicData.Part.WEAPON_ECLIPTICUM:
				stepArr = [RelicData.Step.ECLIPTIC_ARCANITE, RelicData.Step.PHANTOM_DISPELLER, RelicData.Step.ECLIPTICUM_ITEMS]; // Steps in reverse order
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, part, step);
				if(value){ preReqs.push(...this.getWeaponPhantomPreReqs(RelicData.Part.WEAPON_OBSCURUM, RelicData.Step.WANING_ARCANITE, value)); } // Previous part, Last step
				else{ preReqs.push(...this.getWeaponPhantomPreReqs(RelicData.Part.WEAPON_OCCULTUM, RelicData.Step.KNOWLEDGE, value)); } // Next part, First step
				break;
			case RelicData.Part.WEAPON_OCCULTUM:
				stepArr = [RelicData.Step.EXCHANGE, RelicData.Step.KNOWLEDGE]; // Steps in reverse order
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, part, step);
				if(value){ preReqs.push(...this.getWeaponPhantomPreReqs(RelicData.Part.WEAPON_ECLIPTICUM, RelicData.Step.ECLIPTIC_ARCANITE, value)); } // Previous part, Last step
				break;
		}
		return preReqs;
	}

	getToolLucisPreReqs(part:RelicData.Part, step:RelicData.Step, value:boolean):Prerequisite[]{
		const preReqs:Prerequisite[] = [];
		let stepArr:RelicData.Step[] = [];

		switch(part){
			default: log.warn(`No PreReqs found for ${part}`); return [];
			case RelicData.Part.TOOL_MASTERCRAFT:
				stepArr = [RelicData.Step.CLASS_QUESTS];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, part, step);

				if(!value){ preReqs.push(...this.getToolLucisPreReqs(RelicData.Part.TOOL_SUPRA, RelicData.Step.SUPRA_ITEMS, value)); } // Next part, First step
				break;
			case RelicData.Part.TOOL_SUPRA:
				stepArr = [RelicData.Step.SUPRA_ITEMS];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, part, step);

				if(value){ preReqs.push(...this.getToolLucisPreReqs(RelicData.Part.TOOL_MASTERCRAFT, RelicData.Step.CLASS_QUESTS, value)); }  // Previous part, Last step
				else{ preReqs.push(...this.getToolLucisPreReqs(RelicData.Part.TOOL_LUCIS, RelicData.Step.LUCIS_ITEMS, value)); } // Next part, First step
				break;
			case RelicData.Part.TOOL_LUCIS:
				stepArr = [RelicData.Step.LUCIS_ITEMS];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, part, step);

				if(value){ preReqs.push(...this.getToolLucisPreReqs(RelicData.Part.TOOL_SUPRA, RelicData.Step.SUPRA_ITEMS, value)); }  // Previous part, Last step
				break;
		}
		return preReqs;
	}

	getToolSkysteelPreReqs(part:RelicData.Part, step:RelicData.Step, value:boolean):Prerequisite[]{
		const preReqs:Prerequisite[] = [];
		let stepArr:RelicData.Step[] = [];

		switch(part){
			default: log.warn(`No PreReqs found for ${part}`); return [];
			case RelicData.Part.TOOL_SKYSTEEL:
				stepArr = [RelicData.Step.PURCHASE];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, part, step);

				if(!value){ preReqs.push(...this.getToolSkysteelPreReqs(RelicData.Part.TOOL_SKYSTEEL_1, RelicData.Step.SKYSTEEL_ITEMS, value)); } // Next part, First step
				break;
			case RelicData.Part.TOOL_SKYSTEEL_1:
				stepArr = [RelicData.Step.SKYSTEEL_ITEMS];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, part, step);

				if(value){ preReqs.push(...this.getToolSkysteelPreReqs(RelicData.Part.TOOL_SKYSTEEL, RelicData.Step.PURCHASE, value)); }  // Previous part, Last step
				else{ preReqs.push(...this.getToolSkysteelPreReqs(RelicData.Part.TOOL_DRAGONSUNG, RelicData.Step.DRAGONSUNG_ITEMS, value)); } // Next part, First step
				break;
			case RelicData.Part.TOOL_DRAGONSUNG:
				stepArr = [RelicData.Step.DRAGONSUNG_ITEMS];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, part, step);

				if(value){ preReqs.push(...this.getToolSkysteelPreReqs(RelicData.Part.TOOL_SKYSTEEL_1, RelicData.Step.SKYSTEEL_ITEMS, value)); }  // Previous part, Last step
				else{ preReqs.push(...this.getToolSkysteelPreReqs(RelicData.Part.TOOL_AUGMENTED_DRAGONSUNG, RelicData.Step.BASIC_GOBBIEGOO, value)); } // Next part, First step
				break;
			case RelicData.Part.TOOL_AUGMENTED_DRAGONSUNG:
				stepArr = [RelicData.Step.BASIC_GOBBIEGOO];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, part, step);

				if(value){ preReqs.push(...this.getToolSkysteelPreReqs(RelicData.Part.TOOL_DRAGONSUNG, RelicData.Step.DRAGONSUNG_ITEMS, value)); }  // Previous part, Last step
				else{ preReqs.push(...this.getToolSkysteelPreReqs(RelicData.Part.TOOL_SKYSUNG, RelicData.Step.VISCOUS_GOBBIEGOO, value)); } // Next part, First step
				break;
			case RelicData.Part.TOOL_SKYSUNG:
				stepArr = [RelicData.Step.VISCOUS_GOBBIEGOO];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, part, step);

				if(value){ preReqs.push(...this.getToolSkysteelPreReqs(RelicData.Part.TOOL_AUGMENTED_DRAGONSUNG, RelicData.Step.BASIC_GOBBIEGOO, value)); }  // Previous part, Last step
				else{ preReqs.push(...this.getToolSkysteelPreReqs(RelicData.Part.TOOL_SKYBUILDERS, RelicData.Step.PARTS, value)); } // Next part, First step
				break;
			case RelicData.Part.TOOL_SKYBUILDERS:
				stepArr = [RelicData.Step.PARTS];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, part, step);

				if(value){ preReqs.push(...this.getToolSkysteelPreReqs(RelicData.Part.TOOL_SKYSUNG, RelicData.Step.VISCOUS_GOBBIEGOO, value)); }  // Previous part, Last step
				break;
		}
		return preReqs;
	}

	getToolSplendorousPreReqs(part:RelicData.Part, step:RelicData.Step, value:boolean):Prerequisite[]{
		const preReqs:Prerequisite[] = [];
		let stepArr:RelicData.Step[] = [];

		switch(part){
			default: log.warn(`No PreReqs found for ${part}`); return [];
			case RelicData.Part.TOOL_SPLENDOROUS:
				stepArr = [RelicData.Step.SPLENDOROUS_PURCHASE];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, part, step);

				if(!value){ preReqs.push(...this.getToolSplendorousPreReqs(RelicData.Part.TOOL_AUGMENTED_SPLENDOROUS, RelicData.Step.SPLENDOROUS_COMPONENT, value)); } // Next part, First step
				break;
			case RelicData.Part.TOOL_AUGMENTED_SPLENDOROUS:
				stepArr = [RelicData.Step.SPLENDOROUS_COMPONENT];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, part, step);

				if(value){ preReqs.push(...this.getToolSplendorousPreReqs(RelicData.Part.TOOL_SPLENDOROUS, RelicData.Step.SPLENDOROUS_PURCHASE, value)); } // Previous part, Last step
				else{ preReqs.push(...this.getToolSplendorousPreReqs(RelicData.Part.TOOL_CRYSTALLINE, RelicData.Step.ADAPTIVE_COMPONENT, value)); } // Next part, First step
				break;
			case RelicData.Part.TOOL_CRYSTALLINE:
				stepArr = [RelicData.Step.ADAPTIVE_COMPONENT];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, part, step);

				if(value){ preReqs.push(...this.getToolSplendorousPreReqs(RelicData.Part.TOOL_AUGMENTED_SPLENDOROUS, RelicData.Step.SPLENDOROUS_COMPONENT, value)); } // Previous part, Last step
				else{ preReqs.push(...this.getToolSplendorousPreReqs(RelicData.Part.TOOL_CHORA_ZOIS_CRYSTALLINE, RelicData.Step.CUSTOMISED_COMPONENT, value)); } // Next part, First step
				break;
			case RelicData.Part.TOOL_CHORA_ZOIS_CRYSTALLINE:
				stepArr = [RelicData.Step.CUSTOMISED_COMPONENT];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, part, step);

				if(value){ preReqs.push(...this.getToolSplendorousPreReqs(RelicData.Part.TOOL_CRYSTALLINE, RelicData.Step.ADAPTIVE_COMPONENT, value)); } // Previous part, Last step
				else{ preReqs.push(...this.getToolSplendorousPreReqs(RelicData.Part.TOOL_BRILLIANT, RelicData.Step.BRILLIANT_COMPONENT, value)); } // Next part, First step
				break;
			case RelicData.Part.TOOL_BRILLIANT:
				stepArr = [RelicData.Step.BRILLIANT_COMPONENT];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, part, step);

				if(value){ preReqs.push(...this.getToolSplendorousPreReqs(RelicData.Part.TOOL_CHORA_ZOIS_CRYSTALLINE, RelicData.Step.CUSTOMISED_COMPONENT, value)); } // Previous part, Last step
				else{ preReqs.push(...this.getToolSplendorousPreReqs(RelicData.Part.TOOL_VRANDTIC_VISIONARYS, RelicData.Step.INSPIRATIONAL_COMPONENT, value)); } // Next part, First step
				break;
			case RelicData.Part.TOOL_VRANDTIC_VISIONARYS:
				stepArr = [RelicData.Step.INSPIRATIONAL_COMPONENT];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, part, step);

				if(value){ preReqs.push(...this.getToolSplendorousPreReqs(RelicData.Part.TOOL_BRILLIANT, RelicData.Step.BRILLIANT_COMPONENT, value)); } // Previous part, Last step
				else{ preReqs.push(...this.getToolSplendorousPreReqs(RelicData.Part.TOOL_LODESTAR, RelicData.Step.NIGHTFORGED_COMPONENT, value)); } // Next part, First step
				break;
			case RelicData.Part.TOOL_LODESTAR:
				stepArr = [RelicData.Step.NIGHTFORGED_COMPONENT];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, part, step);

				if(value){ preReqs.push(...this.getToolSplendorousPreReqs(RelicData.Part.TOOL_VRANDTIC_VISIONARYS, RelicData.Step.INSPIRATIONAL_COMPONENT, value)); } // Previous part, Last step
				break;
		}
		return preReqs;
	}

	getToolCosmicPreReqs(part:RelicData.Part, step:RelicData.Step, value:boolean):Prerequisite[]{
		const preReqs:Prerequisite[] = [];
		let stepArr:RelicData.Step[] = [];

		switch(part){
			default: log.warn(`No PreReqs found for ${part}`); return [];
			case RelicData.Part.TOOL_COSMIC:
				stepArr = [
					RelicData.Step.COSMIC,
					RelicData.Step.PROTOTYPE_08,
					RelicData.Step.PROTOTYPE_07,
					RelicData.Step.PROTOTYPE_06,
					RelicData.Step.PROTOTYPE_05,
					RelicData.Step.PROTOTYPE_04,
					RelicData.Step.PROTOTYPE_03,
					RelicData.Step.PROTOTYPE_02,
					RelicData.Step.PROTOTYPE_01,
				];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, part, step);

				if(!value){ preReqs.push(...this.getToolCosmicPreReqs(RelicData.Part.TOOL_STELLAR, RelicData.Step.COSMIC_11, value)); } // Next part, First step
				break;
			case RelicData.Part.TOOL_STELLAR:
				stepArr = [RelicData.Step.STELLAR, RelicData.Step.COSMIC_14, RelicData.Step.COSMIC_13, RelicData.Step.COSMIC_12, RelicData.Step.COSMIC_11];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, part, step);

				if(value){ preReqs.push(...this.getToolCosmicPreReqs(RelicData.Part.TOOL_COSMIC, RelicData.Step.COSMIC, value)); } // Previous part, Last step
				else{ preReqs.push(...this.getToolCosmicPreReqs(RelicData.Part.TOOL_HYPER, RelicData.Step.STELLAR11, value)); } // Next part, First step
				break;
			case RelicData.Part.TOOL_HYPER:
				stepArr = [RelicData.Step.HYPER, RelicData.Step.STELLAR12, RelicData.Step.STELLAR11];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, part, step);

				if(value){ preReqs.push(...this.getToolCosmicPreReqs(RelicData.Part.TOOL_STELLAR, RelicData.Step.STELLAR, value)); } // Previous part, Last step
				else{ preReqs.push(...this.getToolCosmicPreReqs(RelicData.Part.TOOL_STARS, RelicData.Step.HYPER11, value)); } // Next part, First step
				break;
			case RelicData.Part.TOOL_STARS:
				stepArr = [RelicData.Step.STARS, RelicData.Step.HYPER12, RelicData.Step.HYPER11];
				if(!value){ stepArr.reverse(); }

				this.addToPreReqs(preReqs, stepArr, RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, part, step);
				if(value){ preReqs.push(...this.getToolCosmicPreReqs(RelicData.Part.TOOL_HYPER, RelicData.Step.HYPER, value)); } // Previous part, Last step
				break;
		}
		return preReqs;
	}

	getTaskItem(step:RelicData.Step, task:RelicData.Task, job?:Job):GameData.Item{
		switch(step){
			default: return GameData.Item.UNKNOWN;
			case RelicData.Step.CLASS_WEAPON: return job ? this.getClassWeaponItem(task, job) : GameData.Item.UNKNOWN;
			case RelicData.Step.OIL: return GameData.Item.QUENCHING_OIL;
			case RelicData.Step.MIST: return GameData.Item.THAVNAIRIAN_MIST;
			case RelicData.Step.ATMAS: return this.getAtmasItem(task);
			case RelicData.Step.SCROLL: return GameData.Item.SUPERIOR_ENCHANTED_INK;
			case RelicData.Step.ALEXANDRITE: return GameData.Item.ALEXANDRITE;
			case RelicData.Step.LIGHT: return GameData.Item.LIGHT;
			case RelicData.Step.SKYLIGHT: return this.getSkylightItem(task);
			case RelicData.Step.ZODIUM: return this.getZodiumItem(task);
			case RelicData.Step.FLAWLESS_ALEXANDRITE: return this.getFlawlessAlexandriteItem(task);
			case RelicData.Step.BRAVES_SCROLL: return this.getBravesScrollItem(task);
			case RelicData.Step.SOUL: return this.getSoulItem(task);
			case RelicData.Step.CRYSTALS: return this.getCrystalsItem(task);
			case RelicData.Step.RUBBER: return task === RelicData.Task.TASK_1 ? GameData.Item.UNIDENTIFIABLE_BONE : GameData.Item.ADAMANTITE_FRANCESCA;
			case RelicData.Step.CARBONCOAT: return task === RelicData.Task.TASK_1 ? GameData.Item.UNIDENTIFIABLE_SHELL : GameData.Item.TITANIUM_ALLOY_MIRROR;
			case RelicData.Step.WATER: return task === RelicData.Task.TASK_1 ? GameData.Item.UNIDENTIFIABLE_ORE : GameData.Item.DISPELLING_ARROW;
			case RelicData.Step.CATALYST: return task === RelicData.Task.TASK_1 ? GameData.Item.UNIDENTIFIABLE_SEEDS : GameData.Item.KINGCAKE;
			case RelicData.Step.OIL_HYPER: return GameData.Item.AETHER_OIL;
			case RelicData.Step.SAND: return task === RelicData.Task.TASK_1 ? GameData.Item.CRYSTAL_SAND : GameData.Item.UMBRITE;
			case RelicData.Step.CLUSTERS: return GameData.Item.SINGING_CLUSTER;
			case RelicData.Step.PNEUMITE: return GameData.Item.PNEUMITE;
			case RelicData.Step.DENSITY: return GameData.Item.AETHERIC_DENSITY;
			case RelicData.Step.BFF: return GameData.Item.ARCHAIC_ENCHANTED_INK;
			case RelicData.Step.ANEMOS_0: return GameData.Item.PROTEAN_CRYSTAL;
			case RelicData.Step.ANEMOS_1: return GameData.Item.PROTEAN_CRYSTAL;
			case RelicData.Step.ANEMOS_2: return GameData.Item.PROTEAN_CRYSTAL;
			case RelicData.Step.ANEMOS: return GameData.Item.PAZUZUS_FEATHER;
			case RelicData.Step.PAGOS: return GameData.Item.FROSTED_PROTEAN_CRYSTAL;
			case RelicData.Step.PAGOS_1: return task === RelicData.Task.TASK_1 ? GameData.Item.PAGOS_CRYSTAL : GameData.Item.FROSTED_PROTEAN_CRYSTAL;
			case RelicData.Step.ELEMENTAL: return task === RelicData.Task.TASK_1 ? GameData.Item.FROSTED_PROTEAN_CRYSTAL : GameData.Item.LOUHIS_ICE;
			case RelicData.Step.ELEMENTAL_1: return GameData.Item.PYROS_CRYSTAL;
			case RelicData.Step.ELEMENTAL_2: return GameData.Item.PYROS_CRYSTAL;
			case RelicData.Step.PYROS: return task === RelicData.Task.TASK_1 ? GameData.Item.PYROS_CRYSTAL : GameData.Item.PENTHESILEAS_FLAME;
			case RelicData.Step.HYDATOS: return GameData.Item.HYDATOS_CRYSTAL;
			case RelicData.Step.HYDATOS_1: return GameData.Item.HYDATOS_CRYSTAL;
			case RelicData.Step.BASE: return GameData.Item.HYDATOS_CRYSTAL;
			case RelicData.Step.EUREKA: return task === RelicData.Task.TASK_1 ? GameData.Item.HYDATOS_CRYSTAL : GameData.Item.CRYSTALLINE_SCALE;
			case RelicData.Step.FRAGMENTS: return GameData.Item.EUREKA_FRAGMENT;
			case RelicData.Step.SCALEPOWDER: return GameData.Item.THAVNAIRIAN_SCALEPOWDER;
			case RelicData.Step.MEMORY: return this.getMemoryItem(task);
			case RelicData.Step.RESIST: return GameData.Item.BITTER_MEMORY_OF_THE_DYING;
			case RelicData.Step.CHANGE_OF_ARMS: return GameData.Item.LOATHSOME_MEMORY_OF_THE_DYING;
			case RelicData.Step.REMEMBERS: return task === RelicData.Task.TASK_1 ? GameData.Item.HAUNTING_MEMORY_OF_THE_DYING : GameData.Item.VEXATIOUS_MEMORY_OF_THE_DYING;
			case RelicData.Step.PATH: return GameData.Item.TIMEWORN_ARTIFACTS;
			case RelicData.Step.SPARE_PARTS: return task === RelicData.Task.TASK_1 ? GameData.Item.COMPACT_AXLE : GameData.Item.COMPACT_SPRING;
			case RelicData.Step.STORY: return task === RelicData.Task.TASK_1 ? GameData.Item.BATTLES_FOR_THE_REALM : GameData.Item.BEYOND_THE_RIFT;
			case RelicData.Step.FOND_MEMORY: return task === RelicData.Task.TASK_1 ? GameData.Item.BLEAK_MEMORY_OF_THE_DYING : GameData.Item.LURID_MEMORY_OF_THE_DYING;
			case RelicData.Step.IRRESISTIBLE: return GameData.Item.RAW_EMOTION;
			case RelicData.Step.MANDERVILLE: return GameData.Item.MANDERIUM_METEORITE;
			case RelicData.Step.DEMIATMA: return this.getDemiatmasItem(task);
			case RelicData.Step.ARCANITE: return GameData.Item.ARCANITE;
			case RelicData.Step.UMBRAE_ITEMS: return this.getUmbraeItem(task);
			case RelicData.Step.AETHERWELL: return this.getAetherwellItem(task);
			case RelicData.Step.WAXING_ARCANITE: return GameData.Item.WAXING_ARCANITE;
			case RelicData.Step.OBSCURUM_ITEMS: return this.getObscurumItem(task);
			case RelicData.Step.CRYSTAL_PASTE: return GameData.Item.CRYSTAL_PASTE;
			case RelicData.Step.WANING_ARCANITE: return GameData.Item.WANING_ARCANITE;
			case RelicData.Step.ECLIPTICUM_ITEMS: return this.getEclipticumItem(task);
			case RelicData.Step.PHANTOM_DISPELLER: return this.getDispellerItem(task);
			case RelicData.Step.ECLIPTIC_ARCANITE: return GameData.Item.ECLIPTIC_ARCANITE;
			case RelicData.Step.AMAZING_MANDERVILLE: return GameData.Item.COMPLEMENTARY_CHONDRITE;
			case RelicData.Step.MAJESTIC_MANDERVILLE: return GameData.Item.AMPLIFYING_ACHONDRITE;
			case RelicData.Step.MANDERVILLOUS: return GameData.Item.COSMIC_CRYSTALLITE;
			case RelicData.Step.SUPRA_ITEMS: return job ? this.getSupraItem(task, job) : GameData.Item.UNKNOWN;
			case RelicData.Step.LUCIS_ITEMS: return job ? this.getLucisItem(task, job) : GameData.Item.UNKNOWN;
			case RelicData.Step.SKYSTEEL_ITEMS: return job ? this.getSkysteel_1Item(task, job) : GameData.Item.UNKNOWN;
			case RelicData.Step.DRAGONSUNG_ITEMS: return job ? this.getDragonsungItem(task, job) : GameData.Item.UNKNOWN;
			case RelicData.Step.BASIC_GOBBIEGOO: return job ? this.getAugmentedDragonsungItem(task, job) : GameData.Item.UNKNOWN;
			case RelicData.Step.VISCOUS_GOBBIEGOO: return job ? this.getSkysungItem(task, job) : GameData.Item.UNKNOWN;
			case RelicData.Step.PARTS: return job ? this.getSkybuildersItem(task, job) : GameData.Item.UNKNOWN;
			case RelicData.Step.SPLENDOROUS_COMPONENT: return job ? this.getSplendorousItem(task, job) : GameData.Item.UNKNOWN;
			case RelicData.Step.ADAPTIVE_COMPONENT: return job ? this.getAdaptiveItem(task, job) : GameData.Item.UNKNOWN;
			case RelicData.Step.CUSTOMISED_COMPONENT: return job ? this.getCustomisedItem(task, job) : GameData.Item.UNKNOWN;
			case RelicData.Step.BRILLIANT_COMPONENT: return job ? this.getBrilliantItem(task, job) : GameData.Item.UNKNOWN;
			case RelicData.Step.INSPIRATIONAL_COMPONENT: return job ? this.getInspirationalItem(task, job) : GameData.Item.UNKNOWN;
			case RelicData.Step.NIGHTFORGED_COMPONENT: return job ? this.getNightforgedItem(task, job) : GameData.Item.UNKNOWN;
			case RelicData.Step.PROTOTYPE_01: return this.getCosmicItem(task); // Same items are required for all steps for the Cosmic Relic Parts
			case RelicData.Step.PROTOTYPE_02: return this.getCosmicItem(task); // Same items are required for all steps for the Cosmic Relic Parts
			case RelicData.Step.PROTOTYPE_03: return this.getCosmicItem(task); // Same items are required for all steps for the Cosmic Relic Parts
			case RelicData.Step.PROTOTYPE_04: return this.getCosmicItem(task); // Same items are required for all steps for the Cosmic Relic Parts
			case RelicData.Step.PROTOTYPE_05: return this.getCosmicItem(task); // Same items are required for all steps for the Cosmic Relic Parts
			case RelicData.Step.PROTOTYPE_06: return this.getCosmicItem(task); // Same items are required for all steps for the Cosmic Relic Parts
			case RelicData.Step.PROTOTYPE_07: return this.getCosmicItem(task); // Same items are required for all steps for the Cosmic Relic Parts
			case RelicData.Step.PROTOTYPE_08: return this.getCosmicItem(task); // Same items are required for all steps for the Cosmic Relic Parts
			case RelicData.Step.COSMIC: return this.getCosmicItem(task); // Same items are required for all steps for the Cosmic Relic Parts
			case RelicData.Step.COSMIC_11: return this.getCosmicItem(task); // Same items are required for all steps for the Cosmic Relic Parts
			case RelicData.Step.COSMIC_12: return this.getCosmicItem(task); // Same items are required for all steps for the Cosmic Relic Parts
			case RelicData.Step.COSMIC_13: return this.getCosmicItem(task); // Same items are required for all steps for the Cosmic Relic Parts
			case RelicData.Step.COSMIC_14: return this.getCosmicItem(task); // Same items are required for all steps for the Cosmic Relic Parts
			case RelicData.Step.STELLAR: return this.getCosmicItem(task); // Same items are required for all steps for the Cosmic Relic Parts
			case RelicData.Step.STELLAR11: return this.getCosmicItem(task); // Same items are required for all steps for the Cosmic Relic Parts
			case RelicData.Step.STELLAR12: return this.getCosmicItem(task); // Same items are required for all steps for the Cosmic Relic Parts
			case RelicData.Step.HYPER: return this.getCosmicItem(task); // Same items are required for all steps for the Cosmic Relic Parts
			case RelicData.Step.HYPER11: return this.getCosmicItem(task); // Same items are required for all steps for the Cosmic Relic Parts
			case RelicData.Step.HYPER12: return this.getCosmicItem(task); // Same items are required for all steps for the Cosmic Relic Parts
			case RelicData.Step.STARS: return this.getCosmicItem(task); // Same items are required for all steps for the Cosmic Relic Parts
			case RelicData.Step.RESPLENDENT: return job ? this.getResplendentItem(task, job) : GameData.Item.UNKNOWN;
		}
	}

	private getClassWeaponItem(task:RelicData.Task, job:Job):GameData.Item{
		switch(job){
			default: return GameData.Item.UNKNOWN;
			case Job.PLD: return task === RelicData.Task.TASK_1 ? GameData.Item.AEOLIAN_SCIMITAR : GameData.Item.BATTLEDANCE_MATERIA_III;
			case Job.WAR: return task === RelicData.Task.TASK_1 ? GameData.Item.BARBARIANS_BARDICHE : GameData.Item.BATTLEDANCE_MATERIA_III;
			case Job.WHM: return task === RelicData.Task.TASK_1 ? GameData.Item.MADMANS_WHISPERING_ROD : GameData.Item.QUICKTONGUE_MATERIA_III;
			case Job.SCH: return task === RelicData.Task.TASK_1 ? GameData.Item.ERUDITES_PICATRIX_OF_HEALING : GameData.Item.QUICKTONGUE_MATERIA_III;
			case Job.MNK: return task === RelicData.Task.TASK_1 ? GameData.Item.WILDLINGS_CESTI : GameData.Item.SAVAGE_AIM_MATERIA_III;
			case Job.DRG: return task === RelicData.Task.TASK_1 ? GameData.Item.CHAMPIONS_LANCE : GameData.Item.SAVAGE_AIM_MATERIA_III;
			case Job.NIN: return task === RelicData.Task.TASK_1 ? GameData.Item.VAMPERS_KNIVES : GameData.Item.HEAVENS_EYE_MATERIA_III;
			case Job.BRD: return task === RelicData.Task.TASK_1 ? GameData.Item.LONGARMS_COMPOSITE_BOW : GameData.Item.HEAVENS_EYE_MATERIA_III;
			case Job.BLM: return task === RelicData.Task.TASK_1 ? GameData.Item.SANGUINE_SCEPTER : GameData.Item.SAVAGE_MIGHT_MATERIA_III;
			case Job.SMN: return task === RelicData.Task.TASK_1 ? GameData.Item.ERUDITES_PICATRIX_OF_CASTING : GameData.Item.SAVAGE_MIGHT_MATERIA_III;
		}
	}

	private getAtmasItem(task:RelicData.Task):GameData.Item{
		switch(task){
			default: return GameData.Item.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Item.ATMA_OF_THE_LION;
			case RelicData.Task.TASK_2: return GameData.Item.ATMA_OF_THE_WATERBEARER;
			case RelicData.Task.TASK_3: return GameData.Item.ATMA_OF_THE_RAM;
			case RelicData.Task.TASK_4: return GameData.Item.ATMA_OF_THE_CRAB;
			case RelicData.Task.TASK_5: return GameData.Item.ATMA_OF_THE_FISH;
			case RelicData.Task.TASK_6: return GameData.Item.ATMA_OF_THE_BULL;
			case RelicData.Task.TASK_7: return GameData.Item.ATMA_OF_THE_SCALES;
			case RelicData.Task.TASK_8: return GameData.Item.ATMA_OF_THE_TWINS;
			case RelicData.Task.TASK_9: return GameData.Item.ATMA_OF_THE_SCORPION;
			case RelicData.Task.TASK_10: return GameData.Item.ATMA_OF_THE_ARCHER;
			case RelicData.Task.TASK_11: return GameData.Item.ATMA_OF_THE_GOAT;
			case RelicData.Task.TASK_12: return GameData.Item.ATMA_OF_THE_MAIDEN;
		}
	}

	private getSkylightItem(task:RelicData.Task):GameData.Item{
		switch(task){
			default: return GameData.Item.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Item.BOMBARD_CORE;
			case RelicData.Task.TASK_2: return GameData.Item.BRONZE_LAKE_CRYSTAL;
			case RelicData.Task.TASK_3: return GameData.Item.SACRED_SPRING_WATER;
			case RelicData.Task.TASK_4: return GameData.Item.HORN_OF_THE_BEAST;
			case RelicData.Task.TASK_5: return GameData.Item.GOBMACHINE_BANGPLATE;
			case RelicData.Task.TASK_6: return GameData.Item.NARASIMHA_HIDE;
			case RelicData.Task.TASK_7: return GameData.Item.SICKLE_FANG;
			case RelicData.Task.TASK_8: return GameData.Item.FURNACE_RING_HQ;
			case RelicData.Task.TASK_9: return GameData.Item.PERFECT_FIREWOOD_HQ;
		}
	}

	private getZodiumItem(task:RelicData.Task):GameData.Item{
		switch(task){
			default: return GameData.Item.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Item.ALLAGAN_RESIN;
			case RelicData.Task.TASK_2: return GameData.Item.VALE_BUBO;
			case RelicData.Task.TASK_3: return GameData.Item.VOIDWEAVE;
			case RelicData.Task.TASK_4: return GameData.Item.AMDAPOR_VELLUM;
			case RelicData.Task.TASK_5: return GameData.Item.INDIGO_PEARL;
			case RelicData.Task.TASK_6: return GameData.Item.PERFECT_MORTAR_HQ;
			case RelicData.Task.TASK_7: return GameData.Item.PERFECT_PESTLE_HQ;
			case RelicData.Task.TASK_8: return GameData.Item.BOMBARD_CORE;
			case RelicData.Task.TASK_9: return GameData.Item.SACRED_SPRING_WATER;
		}
	}

	private getFlawlessAlexandriteItem(task:RelicData.Task):GameData.Item{
		switch(task){
			default: return GameData.Item.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Item.BOMBARD_CORE;
			case RelicData.Task.TASK_2: return GameData.Item.BRASS_KETTLE;
			case RelicData.Task.TASK_3: return GameData.Item.SACRED_SPRING_WATER;
			case RelicData.Task.TASK_4: return GameData.Item.LOST_TREASURE_OF_AMDAPOR;
			case RelicData.Task.TASK_5: return GameData.Item.LOST_TREASURE_OF_PHAROS_SIRIUS;
			case RelicData.Task.TASK_6: return GameData.Item.LOST_TREASURE_OF_TAM_TARA;
			case RelicData.Task.TASK_7: return GameData.Item.LOST_TREASURE_OF_STONE_VIGIL;
			case RelicData.Task.TASK_8: return GameData.Item.TAILOR_MADE_EEL_PIE_HQ;
			case RelicData.Task.TASK_9: return GameData.Item.PERFECT_CLOTH_HQ;
		}
	}

	private getBravesScrollItem(task:RelicData.Task):GameData.Item{
		switch(task){
			default: return GameData.Item.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Item.TONBERRY_KING_BLOOD;
			case RelicData.Task.TASK_2: return GameData.Item.ROYAL_GIGANT_BLOOD;
			case RelicData.Task.TASK_3: return GameData.Item.KRAKEN_BLOOD;
			case RelicData.Task.TASK_4: return GameData.Item.VICEGERENT_BLOOD;
			case RelicData.Task.TASK_5: return GameData.Item.PERFECT_VELLUM_HQ;
			case RelicData.Task.TASK_6: return GameData.Item.PERFECT_POUNCE_HQ;
			case RelicData.Task.TASK_7: return GameData.Item.BOMBARD_CORE;
			case RelicData.Task.TASK_8: return GameData.Item.FURITE_SAND;
			case RelicData.Task.TASK_9: return GameData.Item.SACRED_SPRING_WATER;
		}
	}

	private getSoulItem(task:RelicData.Task):GameData.Item{
		switch(task){
			default: return GameData.Item.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Item.MAHATMA_OF_THE_RAM;
			case RelicData.Task.TASK_2: return GameData.Item.MAHATMA_OF_THE_BULL;
			case RelicData.Task.TASK_3: return GameData.Item.MAHATMA_OF_THE_TWINS;
			case RelicData.Task.TASK_4: return GameData.Item.MAHATMA_OF_THE_CRAB;
			case RelicData.Task.TASK_5: return GameData.Item.MAHATMA_OF_THE_LION;
			case RelicData.Task.TASK_6: return GameData.Item.MAHATMA_OF_THE_MAIDEN;
			case RelicData.Task.TASK_7: return GameData.Item.MAHATMA_OF_THE_SCALES;
			case RelicData.Task.TASK_8: return GameData.Item.MAHATMA_OF_THE_SCORPION;
			case RelicData.Task.TASK_9: return GameData.Item.MAHATMA_OF_THE_ARCHER;
			case RelicData.Task.TASK_10: return GameData.Item.MAHATMA_OF_THE_GOAT;
			case RelicData.Task.TASK_11: return GameData.Item.MAHATMA_OF_THE_WATERBEARER;
			case RelicData.Task.TASK_12: return GameData.Item.MAHATMA_OF_THE_FISH;
		}
	}

	private getCrystalsItem(task:RelicData.Task):GameData.Item{
		switch(task){
			default: return GameData.Item.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Item.LUMINOUS_WIND_CRYSTAL;
			case RelicData.Task.TASK_2: return GameData.Item.LUMINOUS_FIRE_CRYSTAL;
			case RelicData.Task.TASK_3: return GameData.Item.LUMINOUS_LIGHTNING_CRYSTAL;
			case RelicData.Task.TASK_4: return GameData.Item.LUMINOUS_ICE_CRYSTAL;
			case RelicData.Task.TASK_5: return GameData.Item.LUMINOUS_EARTH_CRYSTAL;
			case RelicData.Task.TASK_6: return GameData.Item.LUMINOUS_WATER_CRYSTAL;
		}
	}

	private getMemoryItem(task:RelicData.Task):GameData.Item{
		switch(task){
			default: return GameData.Item.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Item.TORTURED_MEMORY_OF_THE_DYING;
			case RelicData.Task.TASK_2: return GameData.Item.SORROWFUL_MEMORY_OF_THE_DYING;
			case RelicData.Task.TASK_3: return GameData.Item.HARROWING_MEMORY_OF_THE_DYING;
		}
	}

	private getDemiatmasItem(task:RelicData.Task):GameData.Item{
		switch(task){
			default: return GameData.Item.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Item.AZURITE_DEMIATMA;
			case RelicData.Task.TASK_2: return GameData.Item.VERDIGRIS_DEMIATMA;
			case RelicData.Task.TASK_3: return GameData.Item.MALACHITE_DEMIATMA;
			case RelicData.Task.TASK_4: return GameData.Item.REALGAR_DEMIATMA;
			case RelicData.Task.TASK_5: return GameData.Item.CAPUT_MORTUUM_DEMIATMA;
			case RelicData.Task.TASK_6: return GameData.Item.ORPIMENT_DEMIATMA;
		}
	}

	private getUmbraeItem(task:RelicData.Task):GameData.Item{
		switch(task){
			default: return GameData.Item.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Item.RRONEEK_GLUE;
			case RelicData.Task.TASK_2: return GameData.Item.UTOHMU_SIDERITE;
			case RelicData.Task.TASK_3: return GameData.Item.SYNTHETIC_DARK_MATTER_ALPHA;
			case RelicData.Task.TASK_4: return GameData.Item.SYNTHETIC_DARK_MATTER_BETA;
			case RelicData.Task.TASK_5: return GameData.Item.SYNTHETIC_DARK_MATTER_GAMMA;
		}
	}

	private getAetherwellItem(task:RelicData.Task):GameData.Item{
		switch(task){
			default: return GameData.Item.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Item.AETHERWELL_GREEN;
			case RelicData.Task.TASK_2: return GameData.Item.AETHERWELL_BLUE;
			case RelicData.Task.TASK_3: return GameData.Item.AETHERWELL_RED;
			case RelicData.Task.TASK_4: return GameData.Item.AETHERWELL_YELLOW;
		}
	}

	private getObscurumItem(task:RelicData.Task):GameData.Item{
		switch(task){
			default: return GameData.Item.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Item.UMBRAL_CLAY;
			case RelicData.Task.TASK_2: return GameData.Item.ASPECTED_AETHEROCONDUCTOR;
			case RelicData.Task.TASK_3: return GameData.Item.ASPECTED_AETHER_AGGLOMERATE;
			case RelicData.Task.TASK_4: return GameData.Item.ASPECTED_AETHEROCATALYST;
		}
	}

	private getEclipticumItem(task:RelicData.Task):GameData.Item{
		switch(task){
			default: return GameData.Item.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Item.MONARCH_WHETSTONE;
			case RelicData.Task.TASK_2: return GameData.Item.ANCESTRAL_ALLOY_INGOT;
			case RelicData.Task.TASK_3: return GameData.Item.ASCENDANT_TWINE;
			case RelicData.Task.TASK_4: return GameData.Item.MAJESTIC_POLISH;
		}
	}

	private getDispellerItem(task:RelicData.Task):GameData.Item{
		switch(task){
			default: return GameData.Item.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Item.PHANTOM_DISPELLER_ALPHA;
			case RelicData.Task.TASK_2: return GameData.Item.PHANTOM_DISPELLER_BETA;
			case RelicData.Task.TASK_3: return GameData.Item.PHANTOM_DISPELLER_GAMMA;
		}
	}

	private getSupraItem(task:RelicData.Task, job:Job):GameData.Item{
		switch(job){
			default: return GameData.Item.UNKNOWN;
			case Job.CRP: return task === RelicData.Task.TASK_1 ? GameData.Item.REINFORCED_SPRUCE_PLYWOOD : GameData.Item.MASTERCRAFT_DEMIMATERIA;
			case Job.BSM: return task === RelicData.Task.TASK_1 ? GameData.Item.BALANCED_DARKSTEEL_HOOK : GameData.Item.MASTERCRAFT_DEMIMATERIA;
			case Job.ARM: return task === RelicData.Task.TASK_1 ? GameData.Item.REINFOCED_DARKSTEEL_WIRE : GameData.Item.MASTERCRAFT_DEMIMATERIA;
			case Job.GSM: return task === RelicData.Task.TASK_1 ? GameData.Item.CALIBRATED_ROSE_GOLD_COG : GameData.Item.MASTERCRAFT_DEMIMATERIA;
			case Job.LTW: return task === RelicData.Task.TASK_1 ? GameData.Item.WATERHARDENED_HIPPOGRYPH_STRAP : GameData.Item.MASTERCRAFT_DEMIMATERIA;
			case Job.WVR: return task === RelicData.Task.TASK_1 ? GameData.Item.INTRICATE_SILVER_BROCADE : GameData.Item.MASTERCRAFT_DEMIMATERIA;
			case Job.ALC: return task === RelicData.Task.TASK_1 ? GameData.Item.CONCENTRATED_SPIRITS_OF_SALT : GameData.Item.MASTERCRAFT_DEMIMATERIA;
			case Job.CUL: return task === RelicData.Task.TASK_1 ? GameData.Item.RICH_TOMATO_RELISH : GameData.Item.MASTERCRAFT_DEMIMATERIA;
			case Job.MIN: return task === RelicData.Task.TASK_1 ? GameData.Item.TALANS_SEAL_OF_MINING : GameData.Item.MASTERCRAFT_DEMIMATERIA;
			case Job.BTN: return task === RelicData.Task.TASK_1 ? GameData.Item.TALANS_SEAL_OF_BOTANY : GameData.Item.MASTERCRAFT_DEMIMATERIA;
			case Job.FSH: return task === RelicData.Task.TASK_1 ? GameData.Item.TALANS_SEAL_OF_FISHING : GameData.Item.MASTERCRAFT_DEMIMATERIA;
		}
	}

	
	private getLucisItem(task:RelicData.Task, job:Job):GameData.Item{
		switch(job){
			default: return GameData.Item.UNKNOWN;
			case Job.CRP: return task === RelicData.Task.TASK_1 ? GameData.Item.PETRIFIED_ORB_HQ : GameData.Item.MOONSTONE;
			case Job.BSM: return task === RelicData.Task.TASK_1 ? GameData.Item.MUMMERS_DAGGERS_HQ : GameData.Item.MOONSTONE;
			case Job.ARM: return task === RelicData.Task.TASK_1 ? GameData.Item.LAPDOG_COLLAR_BELL_HQ : GameData.Item.MOONSTONE;
			case Job.GSM: return task === RelicData.Task.TASK_1 ? GameData.Item.FLUORITE_LENS_HQ : GameData.Item.MOONSTONE;
			case Job.LTW: return task === RelicData.Task.TASK_1 ? GameData.Item.PATENT_LEATHER_HQ : GameData.Item.MOONSTONE;
			case Job.WVR: return task === RelicData.Task.TASK_1 ? GameData.Item.CAMLET_HQ : GameData.Item.MOONSTONE;
			case Job.ALC: return task === RelicData.Task.TASK_1 ? GameData.Item.ENCHANTED_QUICKSILVER_HQ : GameData.Item.MOONSTONE;
			case Job.CUL: return task === RelicData.Task.TASK_1 ? GameData.Item.DUCK_BROTH_HQ : GameData.Item.MOONSTONE;
			case Job.MIN: return task === RelicData.Task.TASK_1 ? GameData.Item.TALANS_SEAL_OF_MINING_MASTERY : GameData.Item.MOONSTONE;
			case Job.BTN: return task === RelicData.Task.TASK_1 ? GameData.Item.TALANS_SEAL_OF_BOTANY_MASTERY : GameData.Item.MOONSTONE;
			case Job.FSH: return task === RelicData.Task.TASK_1 ? GameData.Item.TALANS_SEAL_OF_FISHING_MASTERY : GameData.Item.MOONSTONE;
		}
	}

	
	private getSkysteel_1Item(task:RelicData.Task, job:Job):GameData.Item{
		switch(job){
			default: return GameData.Item.UNKNOWN;
			case Job.CRP: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_PETRIFIED_ORB_HQ : GameData.Item.UNKNOWN;
			case Job.BSM: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_RIVETS_HQ : GameData.Item.UNKNOWN;
			case Job.ARM: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_WIRE_HQ : GameData.Item.UNKNOWN;
			case Job.GSM: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_WHETSTONE_HQ : GameData.Item.UNKNOWN;
			case Job.LTW: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_LEATHER_HQ : GameData.Item.UNKNOWN;
			case Job.WVR: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_MOONBEAM_SILK_HQ : GameData.Item.UNKNOWN;
			case Job.ALC: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_SYNTHETIC_RESIN_HQ : GameData.Item.UNKNOWN;
			case Job.CUL: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_SEED_EXTRACT_HQ : GameData.Item.UNKNOWN;
			case Job.MIN: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_OBSIDIAN : GameData.Item.ODDLY_SPECIFIC_MINERAL_SAND;
			case Job.BTN: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_LATEX : GameData.Item.ODDLY_SPECIFIC_FOSSIL_DUST;
			case Job.FSH: return task === RelicData.Task.TASK_1 ? GameData.Item.THINKERS_CORAL : GameData.Item.UNKNOWN;
		}
	}

	
	private getDragonsungItem(task:RelicData.Task, job:Job):GameData.Item{
		switch(job){
			default: return GameData.Item.UNKNOWN;
			case Job.CRP: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_SHAFT_HQ : GameData.Item.UNKNOWN;
			case Job.BSM: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_FITTING_HQ : GameData.Item.UNKNOWN;
			case Job.ARM: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_CHAINMAIL_SHEET_HQ : GameData.Item.UNKNOWN;
			case Job.GSM: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_GEMSTONE_HQ : GameData.Item.UNKNOWN;
			case Job.LTW: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_VELLUM_HQ : GameData.Item.UNKNOWN;
			case Job.WVR: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_VELVET_HQ : GameData.Item.UNKNOWN;
			case Job.ALC: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_GLASS_HQ : GameData.Item.UNKNOWN;
			case Job.CUL: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_SEED_FLOUR_HQ : GameData.Item.UNKNOWN;
			case Job.MIN: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_DARK_MATTER : GameData.Item.ODDLY_SPECIFIC_STRIKING_STONE;
			case Job.BTN: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_AMBER : GameData.Item.ODDLY_SPECIFIC_BAUBLE;
			case Job.FSH: return task === RelicData.Task.TASK_1 ? GameData.Item.DRAGONSPINE : GameData.Item.UNKNOWN;
		}
	}

	
	private getAugmentedDragonsungItem(task:RelicData.Task, job:Job):GameData.Item{
		switch(job){
			default: return GameData.Item.UNKNOWN;
			case Job.CRP: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_CEDAR_LUMBER : GameData.Item.UNKNOWN;
			case Job.BSM: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_IRON_NAILS : GameData.Item.UNKNOWN;
			case Job.ARM: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_MYTHRIL_RINGS : GameData.Item.UNKNOWN;
			case Job.GSM: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_SILVER_NUGGET : GameData.Item.UNKNOWN;
			case Job.LTW: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_GAGANASKIN_STRAP : GameData.Item.UNKNOWN;
			case Job.WVR: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_CLOTH : GameData.Item.UNKNOWN;
			case Job.ALC: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_GLUE : GameData.Item.UNKNOWN;
			case Job.CUL: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_OIL : GameData.Item.UNKNOWN;
			case Job.MIN: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_SCHORL : GameData.Item.ODDLY_SPECIFIC_LANDBORNE_AETHERSAND;
			case Job.BTN: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_DARK_CHESTNUT_LOG : GameData.Item.ODDLY_SPECIFIC_LEAFBORNE_AETHERSAND;
			case Job.FSH: return task === RelicData.Task.TASK_1 ? GameData.Item.PETAL_SHELL : GameData.Item.UNKNOWN;
		}
	}

	
	private getSkysungItem(task:RelicData.Task, job:Job):GameData.Item{
		switch(job){
			default: return GameData.Item.UNKNOWN;
			case Job.CRP: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_CEDAR_PLANK : GameData.Item.UNKNOWN;
			case Job.BSM: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_IRON_INGOT : GameData.Item.UNKNOWN;
			case Job.ARM: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_MYTHRIL_PLATE : GameData.Item.UNKNOWN;
			case Job.GSM: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_SILVER_INGOT : GameData.Item.UNKNOWN;
			case Job.LTW: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_GAGANA_LEATHER : GameData.Item.UNKNOWN;
			case Job.WVR: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_UNDYED_WOOLEN_CLOTH : GameData.Item.UNKNOWN;
			case Job.ALC: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_RUBBER : GameData.Item.UNKNOWN;
			case Job.CUL: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_PASTE : GameData.Item.UNKNOWN;
			case Job.MIN: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_PRIMORDIAL_ORE : GameData.Item.ODDLY_SPECIFIC_PRIMORDIAL_ASPHALTUM;
			case Job.BTN: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_SPECIFIC_PRIMORDIAL_LOG : GameData.Item.ODDLY_SPECIFIC_PRIMORDIAL_RESIN;
			case Job.FSH: return task === RelicData.Task.TASK_1 ? GameData.Item.ALLAGAN_HUNTER : GameData.Item.UNKNOWN;
		}
	}

	
	private getSkybuildersItem(task:RelicData.Task, job:Job):GameData.Item{
		switch(job){
			default: return GameData.Item.UNKNOWN;
			case Job.CRP: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_DELICATE_PINE_LUMBER : GameData.Item.UNKNOWN;
			case Job.BSM: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_DELICATE_SILVER_GEAR : GameData.Item.UNKNOWN;
			case Job.ARM: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_DELICATE_WOLFRAM_SQUARE : GameData.Item.UNKNOWN;
			case Job.GSM: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_DELICATE_CELESTINE : GameData.Item.UNKNOWN;
			case Job.LTW: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_DELICATE_GAZELLE_LEATHER : GameData.Item.UNKNOWN;
			case Job.WVR: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_DELICATE_RHEA_CLOTH : GameData.Item.UNKNOWN;
			case Job.ALC: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_DELICATE_HOLY_WATER : GameData.Item.UNKNOWN;
			case Job.CUL: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_DELICATE_SHARK_OIL : GameData.Item.UNKNOWN;
			case Job.MIN: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_DELICATE_ADAMANTITE_ORE : GameData.Item.ODDLY_DELICATE_RAW_JADE;
			case Job.BTN: return task === RelicData.Task.TASK_1 ? GameData.Item.ODDLY_DELICATE_FEATHER : GameData.Item.ODDLY_DELICATE_BIRCH_LOG;
			case Job.FSH: return task === RelicData.Task.TASK_1 ? GameData.Item.FLINTSTRIKE : GameData.Item.PICKLED_POM;
		}
	}

	
	private getSplendorousItem(task:RelicData.Task, job:Job):GameData.Item{
		switch(job){
			default: return GameData.Item.UNKNOWN;
			case Job.CRP: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_CHAIR : GameData.Item.UNKNOWN;
			case Job.BSM: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_WALL_LANTERN : GameData.Item.UNKNOWN;
			case Job.ARM: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_ORNATE_DOOR : GameData.Item.UNKNOWN;
			case Job.GSM: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_VANITY_MIRROR : GameData.Item.UNKNOWN;
			case Job.LTW: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_RUG : GameData.Item.UNKNOWN;
			case Job.WVR: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_SWAG_VALANCE : GameData.Item.UNKNOWN;
			case Job.ALC: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_COSMETICS_BOX : GameData.Item.UNKNOWN;
			case Job.CUL: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_PIXIEBERRY_TEA : GameData.Item.UNKNOWN;
			case Job.MIN: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_PRISMSTONE : GameData.Item.SPLENDOROUS_WATER_SHARD;
			case Job.BTN: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_WATTLE_PETRIBARK : GameData.Item.SPLENDOROUS_EARTH_SHARD;
			case Job.FSH: return task === RelicData.Task.TASK_1 ? GameData.Item.PLATINUM_SEAHORSE : GameData.Item.CLAVEKEEPER;
		}
	}

	
	private getAdaptiveItem(task:RelicData.Task, job:Job):GameData.Item{
		switch(job){
			default: return GameData.Item.UNKNOWN;
			case Job.CRP: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_MARIMBA : GameData.Item.UNKNOWN;
			case Job.BSM: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_COFFEE_BREWER : GameData.Item.UNKNOWN;
			case Job.ARM: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_BENCH : GameData.Item.UNKNOWN;
			case Job.GSM: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_ASTROSCOPE : GameData.Item.UNKNOWN;
			case Job.LTW: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_LEATHER_SOFA : GameData.Item.UNKNOWN;
			case Job.WVR: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_RED_CARPET : GameData.Item.UNKNOWN;
			case Job.ALC: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_ELIXIR_BOTTLE : GameData.Item.UNKNOWN;
			case Job.CUL: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_PIXIEBERRY_TART : GameData.Item.UNKNOWN;
			case Job.MIN: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_RED_MALACHITE : GameData.Item.ADAPTIVE_FIRE_CRYSTAL;
			case Job.BTN: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_LEVIN_MINT : GameData.Item.ADAPTIVE_LIGHTNING_CRYSTAL;
			case Job.FSH: return task === RelicData.Task.TASK_1 ? GameData.Item.MIRROR_IMAGE : GameData.Item.SPANGLED_PIRARUCU;
		}
	}

	
	private getCustomisedItem(task:RelicData.Task, job:Job):GameData.Item{
		switch(job){
			default: return GameData.Item.UNKNOWN;
			case Job.CRP: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_PICTURE_FRAME : GameData.Item.UNKNOWN;
			case Job.BSM: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_SAMURAI_BLADE : GameData.Item.UNKNOWN;
			case Job.ARM: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_AQUARIUM : GameData.Item.UNKNOWN;
			case Job.GSM: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_GLAIVES : GameData.Item.UNKNOWN;
			case Job.LTW: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_VARSITY_SHOES : GameData.Item.UNKNOWN;
			case Job.WVR: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_LINEN_PARASOL : GameData.Item.UNKNOWN;
			case Job.ALC: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_TOPIARY_MOOGLE : GameData.Item.UNKNOWN;
			case Job.CUL: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_SQUID_BAGUETTE : GameData.Item.UNKNOWN;
			case Job.MIN: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_SOILED_FEMUR : GameData.Item.CUSTOM_ICE_CRYSTAL;
			case Job.BTN: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEURS_MIRACLE_APPLE : GameData.Item.CUSTOM_WIND_CRYSTAL;
			case Job.FSH: return task === RelicData.Task.TASK_1 ? GameData.Item.GOLD_DUSTFISH : GameData.Item.FORGIVEN_MELANCHOLY;
		}
	}

	
	private getBrilliantItem(task:RelicData.Task, job:Job):GameData.Item{
		switch(job){
			default: return GameData.Item.UNKNOWN;
			case Job.CRP: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_BOOKSHELF : GameData.Item.UNKNOWN;
			case Job.BSM: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_CHANDELIER : GameData.Item.UNKNOWN;
			case Job.ARM: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_ESCUTCHEON : GameData.Item.UNKNOWN;
			case Job.GSM: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_BAGHNAKHS : GameData.Item.UNKNOWN;
			case Job.LTW: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_DRINKING_APKALLU : GameData.Item.UNKNOWN;
			case Job.WVR: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_JACKET : GameData.Item.UNKNOWN;
			case Job.ALC: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_PLANTER_PARTITION : GameData.Item.UNKNOWN;
			case Job.CUL: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_SPAGHETTI_AL_NERO : GameData.Item.UNKNOWN;
			case Job.MIN: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_AURUM_REGIS_ORE : GameData.Item.BRILLIANT_LIGHTNING_CLUSTER;
			case Job.BTN: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_CLOVES : GameData.Item.BRILLIANT_EARTH_CLUSTER;
			case Job.FSH: return task === RelicData.Task.TASK_1 ? GameData.Item.OIL_SLICK : GameData.Item.GONZALOS_GRACE;
		}
	}

	
	private getInspirationalItem(task:RelicData.Task, job:Job):GameData.Item{
		switch(job){
			default: return GameData.Item.UNKNOWN;
			case Job.CRP: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_BAMBOO_FENCE : GameData.Item.UNKNOWN;
			case Job.BSM: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_ROUSING_CHRONOMETER : GameData.Item.UNKNOWN;
			case Job.ARM: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_TRUMPET : GameData.Item.UNKNOWN;
			case Job.GSM: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_WASHBASIN : GameData.Item.UNKNOWN;
			case Job.LTW: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_TARGE : GameData.Item.UNKNOWN;
			case Job.WVR: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_PETASOS : GameData.Item.UNKNOWN;
			case Job.ALC: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_LUNAR_CURTAIN : GameData.Item.UNKNOWN;
			case Job.CUL: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_CRAB_CAKES : GameData.Item.UNKNOWN;
			case Job.MIN: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_ASPHALTUM : GameData.Item.INSPIRATIONAL_WIND_CLUSTER;
			case Job.BTN: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_GIANTHIVE_CHIP : GameData.Item.INSPIRATIONAL_FIRE_CLUSTER;
			case Job.FSH: return task === RelicData.Task.TASK_1 ? GameData.Item.DEADWOOD_SHADOW : GameData.Item.RONKAN_BULLION;
		}
	}

	
	private getNightforgedItem(task:RelicData.Task, job:Job):GameData.Item{
		switch(job){
			default: return GameData.Item.UNKNOWN;
			case Job.CRP: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOSISSEUR_SHISHI_ODOSHI : GameData.Item.UNKNOWN;
			case Job.BSM: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOSISSEUR_RETAINER_BELL : GameData.Item.UNKNOWN;
			case Job.ARM: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOSISSEUR_MARCHING_HORN : GameData.Item.UNKNOWN;
			case Job.GSM: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOSISSEUR_MARBLE_FOUNTAIN : GameData.Item.UNKNOWN;
			case Job.LTW: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOSISSEUR_LEATHER_JACKET : GameData.Item.UNKNOWN;
			case Job.WVR: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOSISSEUR_FAT_CAT_SOFA : GameData.Item.UNKNOWN;
			case Job.ALC: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOSISSEUR_TINCTURE_OF_VITALITY : GameData.Item.UNKNOWN;
			case Job.CUL: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOSISSEUR_CHILI_CRAB : GameData.Item.UNKNOWN;
			case Job.MIN: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_RAW_ONYX : GameData.Item.NIGHTFORGED_ICE_CLUSTER;
			case Job.BTN: return task === RelicData.Task.TASK_1 ? GameData.Item.CONNOISSEUR_GLIMSHROOM : GameData.Item.NIGHTFORGED_WATER_CLUSTER;
			case Job.FSH: return task === RelicData.Task.TASK_1 ? GameData.Item.LITTLE_BOUNTY : GameData.Item.SAINT_FATHRICS_FACE;
		}
	}

	private getCosmicItem(task:RelicData.Task):GameData.Item{
		switch(task){
			default: return GameData.Item.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Item.COSMIC_DATA_I;
			case RelicData.Task.TASK_2: return GameData.Item.COSMIC_DATA_II;
			case RelicData.Task.TASK_3: return GameData.Item.COSMIC_DATA_III;
			case RelicData.Task.TASK_4: return GameData.Item.COSMIC_DATA_IV;
			case RelicData.Task.TASK_5: return GameData.Item.COSMIC_DATA_V;
			case RelicData.Task.TASK_6: return GameData.Item.COSMIC_DATA_VI;
			case RelicData.Task.TASK_7: return GameData.Item.COSMIC_DATA_VII;
		}
	}

	private getResplendentItem(task:RelicData.Task, job:Job):GameData.Item{
		let componentA = GameData.Item.UNKNOWN;
		let componentB = GameData.Item.UNKNOWN;
		let componentC = GameData.Item.UNKNOWN;
		let finalMaterial = GameData.Item.UNKNOWN;

		switch(job){
			default: return GameData.Item.UNKNOWN;
			case Job.CRP:
				componentA = GameData.Item.RESPLENDENT_CRP_COMPONENT_A;
				componentB = GameData.Item.RESPLENDENT_CRP_COMPONENT_B;
				componentC = GameData.Item.RESPLENDENT_CRP_COMPONENT_C;
				finalMaterial = GameData.Item.RESPLENDENT_CRP_MATERIAL_FINAL;
				break;
			case Job.BSM:
				componentA = GameData.Item.RESPLENDENT_BSM_COMPONENT_A;
				componentB = GameData.Item.RESPLENDENT_BSM_COMPONENT_B;
				componentC = GameData.Item.RESPLENDENT_BSM_COMPONENT_C;
				finalMaterial = GameData.Item.RESPLENDENT_BSM_MATERIAL_FINAL;
				break;
			case Job.ARM:
				componentA = GameData.Item.RESPLENDENT_ARM_COMPONENT_A;
				componentB = GameData.Item.RESPLENDENT_ARM_COMPONENT_B;
				componentC = GameData.Item.RESPLENDENT_ARM_COMPONENT_C;
				finalMaterial = GameData.Item.RESPLENDENT_ARM_MATERIAL_FINAL;
				break;
			case Job.GSM:
				componentA = GameData.Item.RESPLENDENT_GSM_COMPONENT_A;
				componentB = GameData.Item.RESPLENDENT_GSM_COMPONENT_B;
				componentC = GameData.Item.RESPLENDENT_GSM_COMPONENT_C;
				finalMaterial = GameData.Item.RESPLENDENT_GSM_MATERIAL_FINAL;
				break;
			case Job.LTW:
				componentA = GameData.Item.RESPLENDENT_LTW_COMPONENT_A;
				componentB = GameData.Item.RESPLENDENT_LTW_COMPONENT_B;
				componentC = GameData.Item.RESPLENDENT_LTW_COMPONENT_C;
				finalMaterial = GameData.Item.RESPLENDENT_LTW_MATERIAL_FINAL;
				break;
			case Job.WVR:
				componentA = GameData.Item.RESPLENDENT_WVR_COMPONENT_A;
				componentB = GameData.Item.RESPLENDENT_WVR_COMPONENT_B;
				componentC = GameData.Item.RESPLENDENT_WVR_COMPONENT_C;
				finalMaterial = GameData.Item.RESPLENDENT_WVR_MATERIAL_FINAL;
				break;
			case Job.ALC:
				componentA = GameData.Item.RESPLENDENT_ALC_COMPONENT_A;
				componentB = GameData.Item.RESPLENDENT_ALC_COMPONENT_B;
				componentC = GameData.Item.RESPLENDENT_ALC_COMPONENT_C;
				finalMaterial = GameData.Item.RESPLENDENT_ALC_MATERIAL_FINAL;
				break;
			case Job.CUL:
				componentA = GameData.Item.RESPLENDENT_CUL_COMPONENT_A;
				componentB = GameData.Item.RESPLENDENT_CUL_COMPONENT_B;
				componentC = GameData.Item.RESPLENDENT_CUL_COMPONENT_C;
				finalMaterial = GameData.Item.RESPLENDENT_CUL_MATERIAL_FINAL;
				break;
			case Job.MIN: return task === RelicData.Task.TASK_1 ? GameData.Item.FOUND_THAT_MINER_7 : GameData.Item.UNKNOWN;
			case Job.BTN: return task === RelicData.Task.TASK_1 ? GameData.Item.FOUND_THAT_BOTANIST_7 : GameData.Item.UNKNOWN;
			case Job.FSH: return task === RelicData.Task.TASK_1 ? GameData.Item.CAUGHT_THAT_7 : GameData.Item.UNKNOWN;
		}

		switch(task){
			default: return GameData.Item.UNKNOWN;
			case RelicData.Task.TASK_1: return componentA;
			case RelicData.Task.TASK_2: return componentB;
			case RelicData.Task.TASK_3: return componentC;
			case RelicData.Task.TASK_4: return finalMaterial;
		}
	}

	getTaskDuty(step:RelicData.Step, task:RelicData.Task):Duty{
		switch(step){
			default: return GameData.Trial.UNKNOWN;
			case RelicData.Step.SKYFIRE_1: return this.getSkyfire_1Duty(task);
			case RelicData.Step.SKYFIRE_2: return this.getSkyfire_2Duty(task);
			case RelicData.Step.NETHERFIRE_1: return this.getNetherfire_1Duty(task);
			case RelicData.Step.SKYFALL_1: return this.getSkyfall_1Duty(task);
			case RelicData.Step.SKYFALL_2: return this.getSkyfall_2Duty(task);
			case RelicData.Step.NETHERFALL_1: return this.getNetherfall_1Duty(task);
			case RelicData.Step.SKYWIND_1: return this.getSkywind_1Duty(task);
			case RelicData.Step.SKYWIND_2: return this.getSkywind_2Duty(task);
			case RelicData.Step.SKYEARTH_1: return this.getSkyearth_1Duty(task);
			case RelicData.Step.DUNGEONS: return this.getAnimaDungeonsDuty(task);
			case RelicData.Step.BFF: return this.getBFFDuty(task);
		}
	}

	private getSkyfire_1Duty(task:RelicData.Task):Duty{
		switch(task){
			default: return GameData.Dungeon.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Leve.AWRY_SALVAGES;
			case RelicData.Task.TASK_5: return GameData.Leve.NECROLOGOS_PALE_OBLATION;
			case RelicData.Task.TASK_8: return GameData.Fate.ENMITY_OF_MY_ENEMY;
			case RelicData.Task.TASK_10: return GameData.Fate.GIANT_SEPS;
			case RelicData.Task.TASK_11: return GameData.Leve.AN_IMP_MOBILE;
			case RelicData.Task.TASK_13: return GameData.Fate.MAKE_IT_RAIN;
			case RelicData.Task.TASK_17: return GameData.Dungeon.TAM_TARA;
			case RelicData.Task.TASK_18: return GameData.Dungeon.STONE_VIGIL;
			case RelicData.Task.TASK_19: return GameData.Dungeon.LOST_CITY_OF_AMDAPOR;
		}
	}

	private getSkyfire_2Duty(task:RelicData.Task):Duty{
		switch(task){
			default: return GameData.Dungeon.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Leve.MUSEUM_IS_CLOSED;
			case RelicData.Task.TASK_3: return GameData.Leve.YELLOW_IS_THE_NEW_BLACK;
			case RelicData.Task.TASK_6: return GameData.Fate.BREACHING_SOUTH_TIDEGATE;
			case RelicData.Task.TASK_10: return GameData.Fate.AIR_SUPPLY;
			case RelicData.Task.TASK_13: return GameData.Fate.HEROES_OF_THE_2ND;
			case RelicData.Task.TASK_16: return GameData.Leve.DONT_FORGET_TO_CRY;
			case RelicData.Task.TASK_17: return GameData.Dungeon.BRAYFLOX;
			case RelicData.Task.TASK_18: return GameData.Dungeon.WANDERERS;
			case RelicData.Task.TASK_19: return GameData.Dungeon.COPPERBELL_HARD;
		}
	}

	private getNetherfire_1Duty(task:RelicData.Task):Duty{
		switch(task){
			default: return GameData.Dungeon.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Fate.ANOTHER_NOTCH;
			case RelicData.Task.TASK_2: return GameData.Leve.ONE_BIG_PROBLEM_SOLVED;
			case RelicData.Task.TASK_5: return GameData.Leve.IF_YOU_PUT_IT_THAT_WAY;
			case RelicData.Task.TASK_8: return GameData.Fate.EVERYTHINGS_BETTER;
			case RelicData.Task.TASK_13: return GameData.Fate.RETURN_TO_CINDER;
			case RelicData.Task.TASK_16: return GameData.Leve.CIRCLING_THE_CERULEUM;
			case RelicData.Task.TASK_17: return GameData.Dungeon.QARN;
			case RelicData.Task.TASK_18: return GameData.Dungeon.HAUKKE_MANOR_HARD;
			case RelicData.Task.TASK_19: return GameData.Dungeon.HALATALI_HARD;
		}
	}

	private getSkyfall_1Duty(task:RelicData.Task):Duty{
		switch(task){
			default: return GameData.Dungeon.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Leve.GO_HOME_TO_MAMA;
			case RelicData.Task.TASK_4: return GameData.Fate.BELLYFULL;
			case RelicData.Task.TASK_5: return GameData.Leve.NECROLOGOS_WHISPERS_OF_THE_GEM;
			case RelicData.Task.TASK_7: return GameData.Fate.KINGS_JUSTICE;
			case RelicData.Task.TASK_12: return GameData.Leve.CIRCLING_THE_CERULEUM;
			case RelicData.Task.TASK_15: return GameData.Fate.QUARTZ_COUPLING;
			case RelicData.Task.TASK_17: return GameData.Dungeon.COPPERBELL;
			case RelicData.Task.TASK_18: return GameData.Dungeon.DZEMAEL_DARKHOLD;
			case RelicData.Task.TASK_19: return GameData.Dungeon.BRAYFLOX_HARD;
		}
	}

	private getSkyfall_2Duty(task:RelicData.Task):Duty{
		switch(task){
			default: return GameData.Dungeon.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Fate.BLACK_AND_NBURU;
			case RelicData.Task.TASK_2: return GameData.Leve.GET_OFF_OUR_LAKE;
			case RelicData.Task.TASK_5: return GameData.Leve.AREAS_A_BIT_SKETCHY;
			case RelicData.Task.TASK_7: return GameData.Fate.BREAKING_DAWN;
			case RelicData.Task.TASK_12: return GameData.Leve.SOMEONES_IN_THE_DOGHOUSE;
			case RelicData.Task.TASK_13: return GameData.Fate.BREACHING_NORTH_TIDEGATE;
			case RelicData.Task.TASK_17: return GameData.Dungeon.TOTO_RAK;
			case RelicData.Task.TASK_18: return GameData.Dungeon.AMDAPOR_KEEP;
			case RelicData.Task.TASK_19: return GameData.Dungeon.HAUKKE_MANOR_HARD;
		}
	}

	private getNetherfall_1Duty(task:RelicData.Task):Duty{
		switch(task){
			default: return GameData.Dungeon.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Fate.CERULEUM_ROAD;
			case RelicData.Task.TASK_2: return GameData.Leve.SUBDUING_THE_SUBPRIME;
			case RelicData.Task.TASK_5: return GameData.Fate.FOUR_WINDS;
			case RelicData.Task.TASK_6: return GameData.Leve.GOT_A_GUT_FEELING_ABOUT_THIS;
			case RelicData.Task.TASK_11: return GameData.Fate.RUDE_AWAKENING;
			case RelicData.Task.TASK_14: return GameData.Leve.WHO_WRITES_HISTORY;
			case RelicData.Task.TASK_17: return GameData.Dungeon.CUTTERS;
			case RelicData.Task.TASK_18: return GameData.Dungeon.PHAROS_SIRIUS;
			case RelicData.Task.TASK_19: return GameData.Dungeon.LOST_CITY_OF_AMDAPOR;
		}
	}

	private getSkywind_1Duty(task:RelicData.Task):Duty{
		switch(task){
			default: return GameData.Dungeon.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Fate.GOOD_TO_BE_BAD;
			case RelicData.Task.TASK_2: return GameData.Leve.BIG_BAD_IDEA;
			case RelicData.Task.TASK_5: return GameData.Leve.SOMEONES_GOT_A_BIG_MOUTH;
			case RelicData.Task.TASK_10: return GameData.Fate.SURPRISE;
			case RelicData.Task.TASK_12: return GameData.Leve.SUBDUING_THE_SUBPRIME;
			case RelicData.Task.TASK_16: return GameData.Fate.IN_SPITE_OF_IT_ALL;
			case RelicData.Task.TASK_17: return GameData.Dungeon.SASTASHA;
			case RelicData.Task.TASK_18: return GameData.Dungeon.AURUM;
			case RelicData.Task.TASK_19: return GameData.Dungeon.HALATALI_HARD;
		}
	}

	private getSkywind_2Duty(task:RelicData.Task):Duty{
		switch(task){
			default: return GameData.Dungeon.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Leve.PUT_YOUR_STOMP_ON_IT;
			case RelicData.Task.TASK_6: return GameData.Fate.WHAT_GORED_BEFORE;
			case RelicData.Task.TASK_7: return GameData.Fate.TAKEN;
			case RelicData.Task.TASK_11: return GameData.Leve.NECROLOGOS_PALE_OBLATION;
			case RelicData.Task.TASK_14: return GameData.Fate.TOWER_OF_POWER;
			case RelicData.Task.TASK_15: return GameData.Leve.BLOODHOUNDS_OF_COERTHAS;
			case RelicData.Task.TASK_17: return GameData.Dungeon.HAUKKE_MANOR;
			case RelicData.Task.TASK_18: return GameData.Dungeon.COPPERBELL_HARD;
			case RelicData.Task.TASK_19: return GameData.Dungeon.BRAYFLOX_HARD;
		}
	}

	private getSkyearth_1Duty(task:RelicData.Task):Duty{
		switch(task){
			default: return GameData.Dungeon.UNKNOWN;
			case RelicData.Task.TASK_3: return GameData.Leve.DONT_FORGET_TO_CRY;
			case RelicData.Task.TASK_4: return GameData.Fate.BIG_BAGOLY_THEORY;
			case RelicData.Task.TASK_8: return GameData.Fate.SCHISM;
			case RelicData.Task.TASK_11: return GameData.Fate.TASTE_OF_FEAR;
			case RelicData.Task.TASK_12: return GameData.Leve.NO_BIG_WHOOP;
			case RelicData.Task.TASK_14: return GameData.Leve.NECROLOGOS_THE_LIMINAL_ONES;
			case RelicData.Task.TASK_17: return GameData.Dungeon.PHAROS_SIRIUS;
			case RelicData.Task.TASK_18: return GameData.Dungeon.HALATALI;
			case RelicData.Task.TASK_19: return GameData.Dungeon.AMDAPOR_KEEP;
		}
	}

	private getAnimaDungeonsDuty(task:RelicData.Task):Duty{
		switch(task){
			default: return GameData.Dungeon.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Dungeon.LOST_CITY_OF_AMDAPOR_HARD;
			case RelicData.Task.TASK_2: return GameData.Dungeon.GUBAL_LIBRARY_HARD;
			case RelicData.Task.TASK_3: return GameData.Dungeon.SOHM_AL_HARD;
		}
	}

	private getBFFDuty(task:RelicData.Task):Duty{
		switch(task){
			default: return GameData.Trial.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Trial.IFRIT_HARD;
			case RelicData.Task.TASK_2: return GameData.Trial.GARUDA_HARD;
			case RelicData.Task.TASK_3: return GameData.Trial.TITAN_HARD;
			case RelicData.Task.TASK_4: return GameData.Trial.MOGGLE_MOG_HARD;
			case RelicData.Task.TASK_5: return GameData.Trial.LEVIATHAN_HARD;
			case RelicData.Task.TASK_6: return GameData.Trial.RAMUH_HARD;
			case RelicData.Task.TASK_7: return GameData.Trial.SHIVA_HARD;
			case RelicData.Task.TASK_8: return GameData.Trial.RAVANA_HARD;
			case RelicData.Task.TASK_9: return GameData.Trial.BISMARCK;
			case RelicData.Task.TASK_10: return GameData.Trial.SOPHIA;
			case RelicData.Task.TASK_11: return GameData.Trial.SEPHIROT;
			case RelicData.Task.TASK_12: return GameData.Trial.ZURVAN;
		}
	}

	getTaskEnemy(step:RelicData.Step, task:RelicData.Task, job?:Job):GameData.Enemy{
		switch(step){
			default: return GameData.Enemy.UNKNOWN;
			case RelicData.Step.BEASTMAN: return job ? this.getBeastmanEnemy(task, job) : GameData.Enemy.UNKNOWN;
			case RelicData.Step.SKYFIRE_1: return this.skyfire_1Enemy(task);
			case RelicData.Step.SKYFIRE_2: return this.skyfire_2Enemy(task);
			case RelicData.Step.NETHERFIRE_1: return this.netherfire_1Enemy(task);
			case RelicData.Step.SKYFALL_1: return this.skyfall_1Enemy(task);
			case RelicData.Step.SKYFALL_2: return this.skyfall_2Enemy(task);
			case RelicData.Step.NETHERFALL_1: return this.netherfall_1Enemy(task);
			case RelicData.Step.SKYWIND_1: return this.skywind_1Enemy(task);
			case RelicData.Step.SKYWIND_2: return this.skywind_2Enemy(task);
			case RelicData.Step.SKYEARTH_1: return this.skyearth_1Enemy(task);
		}
	}

	private getBeastmanEnemy(task:RelicData.Task, job:Job):GameData.Enemy{
		switch(job){
			default: return GameData.Enemy.UNKNOWN;
			case Job.PLD: return task === RelicData.Task.TASK_1 ? GameData.Enemy.ZAHARAK_LANCER : task === RelicData.Task.TASK_2 ? GameData.Enemy.ZAHARAK_PUGILIST : GameData.Enemy.ZAHARAK_THAUMATURGE;
			case Job.WAR: return task === RelicData.Task.TASK_1 ? GameData.Enemy.UGHAMARO_QUARRYMAN : task === RelicData.Task.TASK_2 ? GameData.Enemy.UGHAMARO_BEDESMAN : GameData.Enemy.UGHAMARO_ROUNDSMAN;
			case Job.WHM: return task === RelicData.Task.TASK_1 ? GameData.Enemy.UGHAMARO_QUARRYMAN : task === RelicData.Task.TASK_2 ? GameData.Enemy.UGHAMARO_BEDESMAN : GameData.Enemy.UGHAMARO_PRIEST;
			case Job.SCH: return task === RelicData.Task.TASK_1 ? GameData.Enemy.SAPSA_SHELFSPINE : task === RelicData.Task.TASK_2 ? GameData.Enemy.SAPSA_SHELFCLAW : GameData.Enemy.SAPSA_SHELFTOOTH;
			case Job.MNK: return task === RelicData.Task.TASK_1 ? GameData.Enemy.ZAHARAK_LANCER : task === RelicData.Task.TASK_2 ? GameData.Enemy.ZAHARAK_PUGILIST : GameData.Enemy.ZAHARAK_ARCHER;
			case Job.DRG: return task === RelicData.Task.TASK_1 ? GameData.Enemy.NATALAN_BOLDWING : task === RelicData.Task.TASK_2 ? GameData.Enemy.NATALAN_FOGCALLER : GameData.Enemy.NATALAN_WINDTALON;
			case Job.NIN: return task === RelicData.Task.TASK_1 ? GameData.Enemy.SAPSA_SHELFSPINE : task === RelicData.Task.TASK_2 ? GameData.Enemy.SAPSA_SHELFCLAW : GameData.Enemy.SAPSA_SHELFTOOTH;
			case Job.BRD: return task === RelicData.Task.TASK_1 ? GameData.Enemy.NATALAN_BOLDWING : task === RelicData.Task.TASK_2 ? GameData.Enemy.NATALAN_FOGCALLER : GameData.Enemy.NATALAN_WINDTALON;
			case Job.BLM: return task === RelicData.Task.TASK_1 ? GameData.Enemy.UGHAMARO_QUARRYMAN : task === RelicData.Task.TASK_2 ? GameData.Enemy.UGHAMARO_BEDESMAN : GameData.Enemy.UGHAMARO_PRIEST;
			case Job.SMN: return task === RelicData.Task.TASK_1 ? GameData.Enemy.VIOLET_SIGH : task === RelicData.Task.TASK_2 ? GameData.Enemy.VIOLET_SCREECH : GameData.Enemy.VIOLET_SNARL;
		}
	}

	private skyfire_1Enemy(task:RelicData.Task):GameData.Enemy{
		switch(task){
			default: return GameData.Enemy.UNKNOWN;
			case RelicData.Task.TASK_2: return GameData.Enemy.DARING_HARRIER;
			case RelicData.Task.TASK_3: return GameData.Enemy.COHORT_VANGUARD_5TH;
			case RelicData.Task.TASK_4: return GameData.Enemy.COHORT_HOPLOMACHUS_4TH;
			case RelicData.Task.TASK_6: return GameData.Enemy.BASILISK;
			case RelicData.Task.TASK_7: return GameData.Enemy.ZANRAK_PUGILIST;
			case RelicData.Task.TASK_9: return GameData.Enemy.MILKROOT_CLUSTER;
			case RelicData.Task.TASK_12: return GameData.Enemy.GIANT_LOGGER;
			case RelicData.Task.TASK_14: return GameData.Enemy.SYNTHETIC_DOBLYN;
			case RelicData.Task.TASK_15: return GameData.Enemy.SHOALSPINE_SAHAGIN;
			case RelicData.Task.TASK_16: return GameData.Enemy.COHORT_HOPLOMACHUS_2ND;
		}
	}

	private skyfire_2Enemy(task:RelicData.Task):GameData.Enemy{
		switch(task){
			default: return GameData.Enemy.UNKNOWN;
			case RelicData.Task.TASK_2: return GameData.Enemy.RAGING_HARRIER;
			case RelicData.Task.TASK_4: return GameData.Enemy.BIAST;
			case RelicData.Task.TASK_5: return GameData.Enemy.NATALAN_BOLDWING;
			case RelicData.Task.TASK_7: return GameData.Enemy.SHOALTOOTH_SAHAGIN;
			case RelicData.Task.TASK_8: return GameData.Enemy.SHELFSCALE_REAVER;
			case RelicData.Task.TASK_9: return GameData.Enemy.UGHAMARO_GOLEM;
			case RelicData.Task.TASK_11: return GameData.Enemy.DULLAHAN;
			case RelicData.Task.TASK_12: return GameData.Enemy.SYLPHEED_SIGH;
			case RelicData.Task.TASK_14: return GameData.Enemy.ZAHARAK_ARCHER;
			case RelicData.Task.TASK_15: return GameData.Enemy.TEMPERED_GLADIATOR;
		}
	}

	private netherfire_1Enemy(task:RelicData.Task):GameData.Enemy{
		switch(task){
			default: return GameData.Enemy.UNKNOWN;
			case RelicData.Task.TASK_3: return GameData.Enemy.HEXING_HARRIER;
			case RelicData.Task.TASK_4: return GameData.Enemy.GIGAS_BONZE;
			case RelicData.Task.TASK_6: return GameData.Enemy.GIANT_LUGGER;
			case RelicData.Task.TASK_7: return GameData.Enemy.WILD_HOG;
			case RelicData.Task.TASK_9: return GameData.Enemy.SYLPHEED_SCREECH;
			case RelicData.Task.TASK_10: return GameData.Enemy.UGHAMARO_ROUNDSMAN;
			case RelicData.Task.TASK_11: return GameData.Enemy.SHELFCLAW_REAVER;
			case RelicData.Task.TASK_12: return GameData.Enemy.COHORT_LAQUEARIUS_2ND;
			case RelicData.Task.TASK_14: return GameData.Enemy.ZAHARAK_FORTUNETELLER;
			case RelicData.Task.TASK_15: return GameData.Enemy.TEMPERED_ORATOR;
		}
	}

	private skyfall_1Enemy(task:RelicData.Task):GameData.Enemy{
		switch(task){
			default: return GameData.Enemy.UNKNOWN;
			case RelicData.Task.TASK_2: return GameData.Enemy.MUDPUPPY;
			case RelicData.Task.TASK_3: return GameData.Enemy.LAKE_COBRA;
			case RelicData.Task.TASK_6: return GameData.Enemy.GIANT_READER;
			case RelicData.Task.TASK_8: return GameData.Enemy.SHELFSCALE_SAHAGIN;
			case RelicData.Task.TASK_9: return GameData.Enemy.SEA_WASP;
			case RelicData.Task.TASK_10: return GameData.Enemy.UGHAMARO_QUARRYMAN;
			case RelicData.Task.TASK_11: return GameData.Enemy.COHORT_EQUES_2ND;
			case RelicData.Task.TASK_13: return GameData.Enemy.MAGITEK_VANGUARD;
			case RelicData.Task.TASK_14: return GameData.Enemy.AMALJAA_LANCER;
			case RelicData.Task.TASK_16: return GameData.Enemy.SYLPHLANDS_SENTINEL;
		}
	}

	private skyfall_2Enemy(task:RelicData.Task):GameData.Enemy{
		switch(task){
			default: return GameData.Enemy.UNKNOWN;
			case RelicData.Task.TASK_3: return GameData.Enemy.GIGAS_BHIKKHU;
			case RelicData.Task.TASK_4: return GameData.Enemy.COHORT_HOPLOMACHUS_5TH;
			case RelicData.Task.TASK_6: return GameData.Enemy.NATALAN_WATCHWOLF;
			case RelicData.Task.TASK_8: return GameData.Enemy.SYLPH_BONNET;
			case RelicData.Task.TASK_9: return GameData.Enemy.KED;
			case RelicData.Task.TASK_10: return GameData.Enemy.COHORT_LAQUEARIUS_4TH;
			case RelicData.Task.TASK_11: return GameData.Enemy.IRON_TORTOISE;
			case RelicData.Task.TASK_14: return GameData.Enemy.SHELFEYE_REAVER;
			case RelicData.Task.TASK_15: return GameData.Enemy.SAPSA_SHELFSCALE;
			case RelicData.Task.TASK_16: return GameData.Enemy.UGHAMARO_BEDESMAN;
		}
	}

	private netherfall_1Enemy(task:RelicData.Task):GameData.Enemy{
		switch(task){
			default: return GameData.Enemy.UNKNOWN;
			case RelicData.Task.TASK_3: return GameData.Enemy.AMALJAA_BRIGAND;
			case RelicData.Task.TASK_4: return GameData.Enemy.COHORT_SECUTOR_4TH;
			case RelicData.Task.TASK_7: return GameData.Enemy.SNOW_WOLF;
			case RelicData.Task.TASK_8: return GameData.Enemy.SAPSA_SHELFCLAW;
			case RelicData.Task.TASK_9: return GameData.Enemy.UGHAMARO_PRIEST;
			case RelicData.Task.TASK_10: return GameData.Enemy.VIOLET_SCREECH;
			case RelicData.Task.TASK_12: return GameData.Enemy.IXALI_WINDTALON;
			case RelicData.Task.TASK_13: return GameData.Enemy.LESSER_KALONG;
			case RelicData.Task.TASK_15: return GameData.Enemy.GIGAS_SOZU;
			case RelicData.Task.TASK_16: return GameData.Enemy.COHORT_LAQUEARIUS_5TH;
		}
	}

	private skywind_1Enemy(task:RelicData.Task):GameData.Enemy{
		switch(task){
			default: return GameData.Enemy.UNKNOWN;
			case RelicData.Task.TASK_3: return GameData.Enemy.HIPPOGRYPH;
			case RelicData.Task.TASK_4: return GameData.Enemy.COHORT_EQUES_5TH;
			case RelicData.Task.TASK_6: return GameData.Enemy.NATALAN_WINDTALON;
			case RelicData.Task.TASK_7: return GameData.Enemy.SAPSA_ELBST;
			case RelicData.Task.TASK_8: return GameData.Enemy.TRENCHTOOTH_SAHAGIN;
			case RelicData.Task.TASK_9: return GameData.Enemy.ELITE_ROUNDSMAN;
			case RelicData.Task.TASK_11: return GameData.Enemy.COHORT_SECUTORES_2ND;
			case RelicData.Task.TASK_13: return GameData.Enemy.AHRIMAN;
			case RelicData.Task.TASK_14: return GameData.Enemy.AMALJAA_THAUMATURGE;
			case RelicData.Task.TASK_15: return GameData.Enemy.SYLPHEED_SNARL;
		}
	}

	private skywind_2Enemy(task:RelicData.Task):GameData.Enemy{
		switch(task){
			default: return GameData.Enemy.UNKNOWN;
			case RelicData.Task.TASK_2: return GameData.Enemy.GIGAS_SHRAMANA;
			case RelicData.Task.TASK_3: return GameData.Enemy.COHORT_SIGNIFER_5TH;
			case RelicData.Task.TASK_4: return GameData.Enemy.WATCHWOLF;
			case RelicData.Task.TASK_5: return GameData.Enemy.DREAMTOAD;
			case RelicData.Task.TASK_8: return GameData.Enemy.ZAHARAK_BATTLE_DRAKE;
			case RelicData.Task.TASK_9: return GameData.Enemy.AMALJAA_ARCHER;
			case RelicData.Task.TASK_10: return GameData.Enemy.COHORT_SIGNIFER_4TH;
			case RelicData.Task.TASK_12: return GameData.Enemy.ELITE_PRIEST;
			case RelicData.Task.TASK_13: return GameData.Enemy.SAPSA_SHELFTOOTH;
			case RelicData.Task.TASK_16: return GameData.Enemy.NATALAN_FOGCALLER;
		}
	}

	private skyearth_1Enemy(task:RelicData.Task):GameData.Enemy{
		switch(task){
			default: return GameData.Enemy.UNKNOWN;
			case RelicData.Task.TASK_1: return GameData.Enemy.VIOLET_SIGH;
			case RelicData.Task.TASK_2: return GameData.Enemy.IXALI_BOLDWING;
			case RelicData.Task.TASK_5: return GameData.Enemy.AMALJAA_SCAVENGER;
			case RelicData.Task.TASK_6: return GameData.Enemy.ZAHARAK_PUGILIST;
			case RelicData.Task.TASK_7: return GameData.Enemy.AXOLOTL;
			case RelicData.Task.TASK_9: return GameData.Enemy.ELITE_QUARRYMAN;
			case RelicData.Task.TASK_10: return GameData.Enemy.COHORT_SIGNIFER_2ND;
			case RelicData.Task.TASK_13: return GameData.Enemy.NATALAN_SWIFTBEAK;
			case RelicData.Task.TASK_15: return GameData.Enemy.COHORT_SECUTOR_5TH;
			case RelicData.Task.TASK_16: return GameData.Enemy.HAPALIT;
		}
	}

	getTaskOther(step:RelicData.Step, task:RelicData.Task, job?:Job):OutputString{
		switch(step){
			default: return "Unknown";
			case RelicData.Step.KNOWLEDGE: return this.getKnowledgeOther(task);
		}
	}

	private getKnowledgeOther(task:RelicData.Task):OutputString{
		switch(task){
			default: return "Unknown";
			case RelicData.Task.TASK_1: return "Urqopacha Tasks";
			case RelicData.Task.TASK_2: return "Kozama'uka Tasks";
			case RelicData.Task.TASK_3: return "Yak T'el Tasks";
			case RelicData.Task.TASK_4: return "Shaaloani Tasks";
			case RelicData.Task.TASK_5: return "Heritage Found Tasks";
			case RelicData.Task.TASK_6: return "Living Memory Tasks";
			case RelicData.Task.TASK_7: return "Leveling Dungeons";
			case RelicData.Task.TASK_8: return "Expert Dungeons";
			case RelicData.Task.TASK_9: return "Trials";
			case RelicData.Task.TASK_10: return "Alliance Raids";
			case RelicData.Task.TASK_11: return "The Arcadion";
		}
	}
}

const relics = new RelicsManager();
export default relics;
